
const amogh = "/images/amogh.webp";
const dharmik = "/images/dharmik.webp";
const goldChandan = "/images/gold-chandan.webp";
const guggal = "/images/guggal.webp";
const guru = "/images/guru-mantra.webp";
const lotus = "/images/lotus.webp";
const samruddhi = "/images/samruddhi.webp";
const utsav = "/images/utsav.webp";
const wood = "/images/wood.webp";
const sandal1 = "/images/sandal1.webp";
const sandal2 = "/images/sandal2.webp";
const sandal3 = "/images/sandal3.webp";
const kastoori1 = "/images/kastoori1.webp";
const kastoori2 = "/images/kastoori2.webp";
const kastoori3 = "/images/kastoori3.webp";
const guggul1 = "/images/guggul1.webp";
const guggul2 = "/images/guggul2.webp";
const guggul3 = "/images/guggul3.webp";
const shristhi1 = "/images/shristhi1.webp";
const shristhi2 = "/images/shristhi2.webp";
const shristhi3 = "/images/shristhi3.webp";
const pleasant1 = "/images/pleasant1.webp";
const pleasant2 = "/images/pleasant2.webp";
const pleasant3 = "/images/pleasant3.webp";
const manthan1 = "/images/manthan1.webp";
const manthan2 = "/images/manthan2.webp";
const manthan3 = "/images/manthan3.webp";
const sudarshan1 = "/images/sudarshan1.webp";
const sudarshan2 = "/images/sudarshan2.webp";
const sudarshan3 = "/images/sudarshan3.webp";
const oudh1 = "/images/oudh1.webp";
const oudh2 = "/images/oudh2.webp";
const oudh3 = "/images/oudh3.webp";
const woods1 = "/images/woods1.webp";
const woods2 = "/images/woods2.webp";
const woods3 = "/images/woods3.webp";
const elegant1 = "/images/elegant1.webp";
const elegant2 = "/images/elegant2.webp";
const elegant3 = "/images/elegant3.webp";
const gurukrupa1 = "/images/gurukrupa1.webp";
const gurukrupa2 = "/images/gurukrupa2.webp";
const gurukrupa3 = "/images/gurukrupa3.webp";
const ramchandan1 = "/images/ramchandan1.webp";
const ramchandan2 = "/images/ramchandan2.webp";
const ramchandan3 = "/images/ramchandan3.webp";
const sagarr = "/images/bhaktisagaragrbatti1.webp";
const sagarr2 = "/images/bhaktisagaragrbatti2.webp";
const sagarr3 = "/images/bhaktisagaragrbatti3.webp";
const dev1 = "/images/devchandan1.webp";
const dev2 = "/images/devchandan2.webp";
const dev3 = "/images/devchandan3.webp";
const sai1 = "/images/saishardhaagarbatti1.webp";
const sai2 = "/images/saishardhaagarbatti2.webp";
const sai3 = "/images/saishardhaagarbatti3.webp";
const satsang1 = "/images/satsang01.webp";
const satsang2 = "/images/satsang02.webp";
const satsang3 = "/images/satsang03.webp";
const hareram1 = "/images/hareramagbatti1.webp";
const hareram2 = "/images/hareramagbatti2.webp";
const hareram3 = "/images/hareramagbatti3.webp";
const white1 = "/images/whiteagarbatti1.webp";
const white2 = "/images/whiteagarbatti2.webp";
const white3 = "/images/whiteagarbatti3.webp";
const namskar1 = "/images/namskar1.webp";
const namskar2 = "/images/namskar2.webp";
const namskar3 = "/images/namskar3.webp";
const vighna1 = "/images/vighnahartaagarbatti1.webp";
const vighna2 = "/images/vighnahartaagarbatti2.webp";
const vighna3 = "/images/vighnahartaagarbatti3.webp";
// const panch1 = "/images/panchratnaagarbattis1.webp";
const panch2 = "/images/panchratnaagarbattis2.webp";
const panch3 = "/images/panchratnaagarbattis3.webp";
const dwarka1 = "/images/dwarkadhish1.webp";
const dwarka2 = "/images/dwarkadhish2.webp";
const dwarka3 = "/images/dwarkadhish3.webp";
const hare1 = "/images/harekrupa1.webp";
const hare2 = "/images/harekrupa2.webp";
const hare3 = "/images/harekrupa3.webp";
const anmol1 = "/images/anmolsugandh1.webp";
const anmol2 = "/images/anmolsugandh2.webp";
const anmol3 = "/images/anmolsugandh3.webp";
const narayani1 = "/images/narayahifloraagarbatti1.webp";
const narayani2 = "/images/narayahifloraagarbatti2.webp";
const narayani3 = "/images/narayahifloraagarbatti3.webp";
const swami1 = "/images/swamisamarth01.webp";
const swami2 = "/images/swamisamarth02.webp";
const swami3 = "/images/swamisamarth03.webp";
const swagat1 = "/images/swagatagartbatti01.webp";
const swagat2 = "/images/swagatagartbatti02.webp";
const swagat3 = "/images/swagatagartbatti03.webp";
const vrindavan1 = "/images/vrindavanagrbatti1.webp";
const vrindavan2 = "/images/vrindavanagrbatti2.webp";
const vibhuti1 = "/images/vibhutiagarbatti01.webp";
const vibhuti2 = "/images/vibhutiagarbatti02.webp";
const oudh011 = "/images/udhagarbatti01.webp";
const oudh022 = "/images/udhagarbatti02.webp";
const sadguru001 = "/images/sadguruagarbatti01.webp";
const sadguru002 = "/images/sadguruagarbatti02.webp";
const satya1 = "/images/satyavinak01.webp";
const satya2 = "/images/satyavinak02.webp";
const satya3 = "/images/satyavinak03.webp";
const satyanarayan1 = "/images/satyanarayan01.webp";
const satyanarayan2 = "/images/satyanarayan02.webp";
const satyanarayan3 = "/images/satyanarayan03.webp";
const seven1 = "/images/sevenheavenagarbatti1.webp";
const seven2 = "/images/sevenheavenagarbatti2.webp";
const seven3 = "/images/sevenheavenagarbatti3.webp";
const sanatan1 = "/images/santanagarbatti01.webp";
const sanatan2 = "/images/santanagarbatti02.webp";
const bhagwati1 = "/images/bhagvatiflora01.webp";
const bhagwati2 = "/images/bhagvatiflora02.webp";
const kesar1 = "/images/kesarchandan01.webp";
const kesar2 = "/images/kesarchandan02.webp";
const kesar3 = "/images/kesarchandan03.webp";

const govardhan1 = "/images/govardhanagarbatti01.webp";
const govardhan2 = "/images/govardhanagarbatti02.webp";
const govardhan3 = "/images/govardhanagarbatti03.webp";
const shristhi11 = "/images/shristhiagarbatti01.webp";
const shristhi12 = "/images/shristhiagarbatti02.webp";
const kasturi01 = "/images/kasmirikasturi1.webp";
const kasturi02 = "/images/kasmirikasturi2.webp";
const paradise1 = "/images/paradiseagarbatti1.webp";
const paradise2 = "/images/paradiseagarbatti2.webp";
const paradise3 = "/images/paradiseagarbatti3.webp";
const krishna1 = "/images/krushnaagarbatti1.webp";
const krishna2 = "/images/krushnaagarbatti2.webp";
const krishna3 = "/images/krushnaagarbatti3.webp";
const ashish1 = "/images/ashishagarbatti1.webp";
const ashish2 = "/images/ashishagarbatti2.webp";
const ashish3 = "/images/ashishagarbatti3.webp";
const berry1 = "/images/berry1.webp";
const berry2 = "/images/berry2.webp";
const blossom1 = "/images/blossom1.webp";
const blossom2 = "/images/blossom2.webp";
const pavitram1 = "/images/pavitram1.webp";
const pavitram2 = "/images/pavitram2.webp";
const garden1 = "/images/gardanrose1.webp";
const garden2 = "/images/gardanrose2.webp";
const sweden1 = "/images/sweden1.webp";
const sweden2 = "/images/sweden2.webp";

// const snow1 = "/images/snowwhite1.webp";
// const snow2 = "/images/snowwhite2.webp";

const chandan1 = "/images/chandanvan1.webp";
const chandan2 = "/images/chandanvan2.webp";
const adishakti1 = "/images/adishaktiagarbatti1.webp";
const adishakti2 = "/images/adishaktiagarbatti2.webp";
const anmolflora1 = "/images/anmolfloraagarbatti1.webp";
const anmolchandan1 = "/images/anmolchandanagrbatti1.webp";
const nagchampa1 = "/images/nagchampaagarbatti1.webp";
const nagchampa2 = "/images/nagchampaagarbatti2.webp";
const richwoods1 = "/images/richwoodsagarbatti1.webp";

// const great1 = "/images/greatagarbatti1.webp";
// const great2 = "/images/greatagarbatti2.webp";

const sai01 = "/images/saiheavan1.webp";
const anmoloudh1 = "/images/anmoloudhagarbatti1.webp";
const anmoloudh2 = "/images/anmoloudhagarbatti2.webp";
const fountain1 = "/images/fountainagarbatti1.webp";
const fountain2 = "/images/fountainagarbatti2.webp";
const kasturisented1 = "/images/kasturisented1.webp";
const kasturisented2 = "/images/kasturisented2.webp";
const kasturisented3 = "/images/kasturisented3.webp";
const wonderfull1 = "/images/wonderfull1.webp";
const wonderfull2 = "/images/wonderfull2.webp";
const wonderfull3 = "/images/wonderfull3.webp";
const beautiful1 = "/images/beautiful1.webp";
const beautiful2 = "/images/beautiful2.webp";
const beautiful3 = "/images/beautiful3.webp";



export const AGARBATTI = [

  
{
  id: "dev-chandan-agarbatti",
  name: "Dev Chandan - Premium Masala Agarbatti",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Pure Sandalwood",
  scent: "Sandal, Woody, Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "100g", mrp: "₹80" },
    { size: "250g", mrp: "₹150" },
  ],

  shortDesc:
    "Premium natural masala agarbatti crafted with Pure Sandal fragrance — warm, woody & sweet aroma that lingers for hours, converting your space into a Spiritual Atmosphere.",

  longDesc:
    "PRAKHYAT – DEV CHANDAN – Crafted with Pure Sandal Fragrance. As Sandal is considered one of the most sacred forms of worshipping Gods, making it a first choice — its warm, woody, sweet smell lingers for hours after burning of the stick, converting your place into a Spiritual Atmosphere and bringing calmness and peace to your life.",

  benefits: [
    "Creates a Pleasant & Sacred Sandal Aroma in your surroundings",
    "Warm, Woody & Sweet fragrance that lingers for hours",
    "Converts your space into a Divine Spiritual Atmosphere",
    "Ideal for Worship, Pooja, Meditation & Yoga sessions",
    "Brings Calmness, Peace & Positive Energy to your life",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural Ingredients",
    "Premium Masala",
    "Long Lasting Aroma",
    "Handcrafted",
  ],

  packing: [
    "100gm - MRP ₹80/-",
    "250gm - MRP ₹150/-",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the sacred Sandal aroma fill your space with calmness and spirituality.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: dev1,
  imgs: [dev1, dev2, dev3],
},
{
  id: "bhakti-sagar-agarbatti",
  name: "Bhakti Sagar - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Fancy Flora Floral",
  scent: "Floral, Fancy, Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",
  weight: [
    { size: "100g", MRP: "₹80" },
    { size: "250g", MRP: "₹150" }
  ],

  shortDesc:
    "Premium natural masala agarbatti with long-lasting Fancy Flora fragrance for pooja, meditation, and peaceful surroundings.",

  longDesc:
    "PRAKHYAT – BHAKTI SAGAR – Fancy Flora Fragrance made from Natural & Pure Ingredients, throwing a Long Lasting Aroma and creating a Pleasant Atmosphere in your surroundings. Ideal for Daily Worship, Pooja, Meditation, Yoga, Stress Relief, and bringing Peace & Positive Energy to your living space.",
benefits: [
  " Creates Pleasant Aroma for Pooja, Meditation, Yoga, Refreshing Atmosphere",
],
   packing: [
    "100gm - MRP ₹80/-",
    "250gm - MRP ₹150/-"
  ],

  usage:
    "Suitable for Daily Pooja, Meditation, Yoga, Spiritual Practices, and Home Fragrance.",

  flipkartUrl: "#",

  img: sagarr,

  imgs: [
    sagarr,
    sagarr2,
    sagarr3
  ]
},








{
  id: "satsang-agarbatti",
  name: "Satsang - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Floral Lavender",
  scent: "Lavender Floral, Fancy, Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",
  itemLength: "23 cm",

  weight: [
    { size: "100g", mrp: "₹80" },
    { size: "250g", mrp: "₹150" },
  ],

  shortDesc:
    "Premium natural masala agarbatti with a soothing Floral Lavender fragrance — crafted for devotion, group prayers, and peaceful spiritual gatherings.",

  longDesc:
    "PRAKHYAT – SATSANG – FLORAL LAVENDER FRAGRANCE. SATSANG is a form of Devotion carried through a group of people doing prayers together of their Deity with meaningful stories and morals to its listeners — passed on from a long legacy. A crafted Masala Agarbatti for Floral Lavender lovers, spreading across the boundaries of your living, filling your space with its soothing aroma giving a reason to pray and stay together.",

  benefits: [
    "Creates a Pleasant & Soothing Floral Lavender Aroma in your surroundings",
    "Perfect for Satsang, Group Prayers & Devotional Gatherings",
    "Ideal for Daily Pooja, Meditation & Yoga sessions",
    "Fills your space with calming fragrance — a reason to pray and stay together",
    "Promotes Peace, Positivity & Refreshing Atmosphere",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala",
  ],

  packing: [
    "100gm - MRP ₹80/-",
    "250gm - MRP ₹150/-",
  ],

  usage:
    "Suitable for Satsang, Group Prayers, Daily Pooja, Meditation, Yoga, Spiritual Gatherings, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the soothing Floral Lavender aroma fill your space with devotion and togetherness.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: satsang1,
  imgs: [satsang1, satsang2, satsang3],
},

{
  id: "sai-shraddha-agarbatti",
  name: "Sai Shraddha - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Modern Flora",
  scent: "Floral, Fancy, Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "100g", mrp: "₹80" },
    { size: "250g", mrp: "₹150" },
  ],

  shortDesc:
    "Premium natural masala agarbatti with a customised Modern Flora fragrance — pure, sacred & unmatchable, just like the blessings of God.",

  longDesc:
    "PRAKHYAT – SAI SHRADDHA – MODERN FLORA FRAGRANCE. Sai Shraddha means Trust in God with no doubt in His mercy — which reaches everyone without any difference and keeps on coming to its devotees. A customised Modern Flora Fragrance and value added product, keeping it aesthetic and beautiful. Just like the blessings of God — pure, sacred & unmatchable.",

  benefits: [
    "Creates a Pleasant & Refreshing Modern Flora Aroma in your surroundings",
    "Ideal for Daily Pooja, Sai Baba Devotion & Spiritual Practices",
    "Enhances focus and devotion during Meditation & Yoga sessions",
    "Pure, Sacred & Aesthetic fragrance — just like God's blessings",
    "Promotes Peace, Positivity & Refreshing Atmosphere",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural Ingredients",
    "Premium Quality",
    "Long Lasting Aroma",
    "Handcrafted",
  ],

  packing: [
    "100gm - MRP ₹80/-",
    "250gm - MRP ₹150/-",
  ],

  usage:
    "Suitable for Daily Pooja, Sai Baba Devotion, Meditation, Yoga, Spiritual Practices, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the sacred Modern Flora aroma fill your space with devotion and peace.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: sai1,
  imgs: [sai1, sai2, sai3],
},



{
  id: "hare-ram-agarbatti",
  name: "Hare Ram - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Fruit Flora",
  scent: "Floral, Fruity, Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "100g", mrp: "₹80" },
    { size: "250g", mrp: "₹150" },
  ],

  shortDesc:
    "Premium natural masala agarbatti with a vibrant Fruit Flora fragrance — uplifts mood, spreads positivity, and fills large spaces with a peppy and wonderful aroma.",

  longDesc:
    "PRAKHYAT – HARE RAM – FRUIT FLORA FRAGRANCE. The name Hare Ram itself is enough for making its space — bringing calmness and a mass appeal. Mainly Fruits and Flora are the best way to uplift moods, creating a happy wave all around and bringing a peppy and wonderful atmosphere. Especially when blending with Masala ingredients, which makes it an ideal preference for Homes, Offices, Shops, and Marriage Halls where you can see large gatherings — with quick spreading and long-lasting effect.",

  benefits: [
    "Creates a Pleasant & Refreshing Fruit Flora Aroma in your surroundings",
    "Uplifts mood and creates a Happy, Peppy atmosphere",
    "Ideal for Homes, Offices, Shops & Large Gathering Halls",
    "Quick spreading fragrance — perfect for large spaces",
    "Ideal for Daily Pooja, Meditation, Yoga & Spiritual Practices",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala",
  ],

  packing: [
    "100gm - MRP ₹80/-",
    "250gm - MRP ₹150/-",
  ],

  usage:
    "Suitable for Daily Pooja, Meditation, Yoga, Homes, Offices, Shops, Marriage Halls, and all Large Gatherings.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the vibrant Fruit Flora aroma uplift your space with positivity and joy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: hareram1,
  imgs: [hareram1, hareram2, hareram3],
},






{
  id: "white-flower-agarbatti",
  name: "White Flower - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Indian Jasmine Champa",
  scent: "Floral, Spicy, Powdery, Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",
  itemLength: "23 cm",

  weight: [
    { size: "100g", mrp: "₹80" },
    { size: "250g", mrp: "₹150" },
  ],

  shortDesc:
    "Premium natural masala agarbatti with Indian Jasmine (Mogra) & Champa fragrance — a timeless duo in Indian perfumery with Floral, Spicy & Powdery notes.",

  longDesc:
    "PRAKHYAT – WHITE FLOWER – INDIAN JASMINE – CHAMPA FRAGRANCE. WHITE FLOWER is a combination of Indian Jasmine (Mogra) & Champa to light up your surroundings with Floral, Spicy, Powdery notes — a resemblance to original flower bouquets. It's a timeless duo in Indian perfumery world, giving a diffusive and refreshing aroma. Made from Natural ingredients.",

  benefits: [
    "Creates a Pleasant & Diffusive Indian Jasmine Champa Aroma in your surroundings",
    "Timeless duo of Mogra & Champa — a classic in Indian Perfumery",
    "Floral, Spicy & Powdery notes resembling original flower bouquets",
    "Ideal for Daily Pooja, Meditation, Yoga & Spiritual Practices",
    "Promotes Refreshing Atmosphere, Peace & Positive Energy",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala",
  ],

  packing: [
    "100gm - MRP ₹80/-",
    "250gm - MRP ₹150/-",
  ],

  usage:
    "Suitable for Daily Pooja, Meditation, Yoga, Spiritual Practices, Relaxation, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the timeless Indian Jasmine Champa aroma light up your space with freshness and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: white1,
  imgs: [white1, white2, white3],
},





{
  id: "namaskar-agarbatti",
  name: "Namaskar - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Amber Floral",
  scent: "Lavender Floral, Fancy, Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",
  itemLength: "23 cm",

  weight: [
    { size: "100g", mrp: "₹80" },
    { size: "250g", mrp: "₹150" },
  ],

  shortDesc:
    "Premium natural masala agarbatti with a soft Amber Floral blend — Rosy, White Lily & Lavender — for Pooja, Meditation & Devotion.",

  longDesc:
    "PRAKHYAT – NAMASKAR – AMBER FLORAL FRAGRANCE. NAMASKAR is a truly blend of Amber, Floral, Rosy, White Lily, giving a soft and smooth Aura. Every breath you take and you will feel like you are roaming in a garden filled with different flowers — making it a perfect choice for Meditation, Devotion, and Religious Functions.",

  benefits: [
    "Creates a Pleasant & Refreshing Aroma in your surroundings",
    "Ideal for Daily Pooja, Devotion & Religious Functions",
    "Enhances focus during Meditation & Yoga sessions",
    "Soft Amber, Rosy & White Lily blend for a calm Aura",
    "Promotes Stress Relief, Peace & Positive Energy",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala",
  ],

  packing: [
    "100gm - MRP ₹80/-",
    "250gm - MRP ₹150/-",
  ],

  usage:
    "Suitable for Daily Pooja, Meditation, Yoga, Devotion, Religious Functions, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the soft Amber Floral aroma fill your space with peace and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: namskar1,
  imgs: [namskar1, namskar2, namskar3],
},



{
  id: "vighnharta-agarbatti",
  name: "Vighnaharta - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Balsamic Natural Dhoop Type",
  scent: "Balsamic, Benzoin, Natural Dhoop Type",
  material: "Wood Powder",
  duration: "1 Hour",
  itemLength: "23 cm",

  weight: [
    { size: "100g", mrp: "₹80" },
    { size: "250g", mrp: "₹175" },
  ],

  shortDesc:
    "Premium natural masala agarbatti with pure Balsamic Benzoin fragrance — a Natural Healer designed to enhance Divine & Spiritual connection in worship places.",

  longDesc:
    "PRAKHYAT – VIGHNAHARTA – BALSAMIC NATURAL DHOOP TYPE. VIGHNAHARTA is designed to be a Natural Healer with possession of pure Balsamic notes, used to enhance the Divine and Spiritual connection. Always treated as top priority in worship places — Benzoin's are Natural aroma enhancers since centuries, used around the globe, known for their superior quality and usability.",

  benefits: [
    "Creates a Pleasant & Sacred Balsamic Aroma in your surroundings",
    "Designed as a Natural Healer — enhances Divine & Spiritual connection",
    "Benzoin — a globally trusted Natural Aroma Enhancer since centuries",
    "Ideal for Worship Places, Daily Pooja, Meditation & Yoga sessions",
    "Promotes Calmness, Peace & Positive Spiritual Energy",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala",
  ],

  packing: [
    "100gm - MRP ₹80/-",
    "250gm - MRP ₹175/-",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the pure Balsamic Benzoin aroma heal your space and elevate your spiritual connection.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: vighna1,
  imgs: [vighna1, vighna2, vighna3],
},

{
  id: "panchratna-agarbatti",
  name: "Panchratna - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Five Flower Blend",
  weight: ["250g"],
  burnTime: "1 Hour",

  desc: "Premium blend of five divine floral fragrances.",

  longDesc:
    "Panchratna Agarbatti combines five sacred floral aromas to create a rich and divine spiritual experience. Perfect for pooja, meditation, and daily rituals, it fills your surroundings with a balanced, soothing, and uplifting fragrance that promotes peace and positivity.",

  material: "Wood Powder",

  benefits: [
    "Creates pleasant aroma for pooja",
    "Perfect for meditation and yoga",
    "Refreshing atmosphere",
    "Brings peace and positive energy"
  ],

  flipkartUrl: "#",

  img: panch2,
  imgs: [ panch2, panch3],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala"
  ]
},

{
  id: "dwarkadhish-agarbatti",
  name: "Dwarkadhish - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Oriental Fragrance",
  scent: "Ancient Floral, Woody, Spicy, Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "75g", mrp: "₹80" },
    { size: "250g", mrp: "₹200" },
  ],

  shortDesc:
    "Premium natural masala agarbatti with a rich Oriental fragrance — a classic blend of Ancient & Modern Aroma with Woody, Floral, Spicy & Heavy Attar notes.",

  longDesc:
    "PRAKHYAT – DWARKADHISH – MADE FROM ORIENTAL FRAGRANCE. This is a Classic combination of Ancient and Modern form of Aroma with Rich, Warm, Exotic notes — like used in Traditional times in India, Middle East and Asian world. A mixture of Woody, Floral, Spicy and Heavy Attars often used in Temples, Monasteries, and Religious Gatherings — connecting to a different Spiritual world and leaving a long lasting memory.",

  benefits: [
    "Creates a Rich, Warm & Exotic Oriental Aroma in your surroundings",
    "Classic blend of Ancient & Modern Aroma — Woody, Floral, Spicy & Heavy Attars",
    "Traditionally used in Temples, Monasteries & Religious Gatherings worldwide",
    "Ideal for Daily Pooja, Meditation, Yoga & Deep Spiritual Practices",
    "Connects you to a different Spiritual world — leaves a long lasting memory",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala",
  ],

  packing: [
    "75gm - MRP ₹80/-",
    "250gm - MRP ₹200/-",
  ],

  usage:
    "Suitable for Daily Pooja, Meditation, Yoga, Temples, Monasteries, Religious Gatherings, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the rich Oriental aroma transport you to a timeless spiritual world.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: dwarka1,
  imgs: [dwarka1, dwarka2, dwarka3],
},



{
  id: "swami-samarth-agarbatti",
  name: "Swami Samarth - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Powdery Floral",
  scent: "Fancy, Fruity, Powdery Floral, Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",
  itemLength: "23 cm",

  weight: [
    { size: "75g", mrp: "₹80" },
    { size: "250g", mrp: "₹200" },
  ],

  shortDesc:
    "Premium natural masala agarbatti with well-balanced Powdery Floral notes of Lily, Jasmine & Rose — divinely crafted for Swami devotees, always giving more than just fragrance.",

  longDesc:
    "PRAKHYAT – SWAMI SAMARTH – POWDERY FLORAL FRAGRANCE. The name Swami Samarth itself is enough for its Introduction. A divinely crafted Masala Agarbatti which has all the fragrance it needs to show the path to Swami devotees — a Powerful note that leaves an impact on its users, always giving more than Fragrance. Well balanced notes of Powdery flowers like Lily, Jasmine & Rose, making it distinguished in its league.",

  benefits: [
    "Creates a Pleasant & Powerful Powdery Floral Aroma in your surroundings",
    "Divinely crafted for Swami Devotees — always giving more than Fragrance",
    "Well-balanced Powdery notes of Lily, Jasmine & Rose — distinguished in its league",
    "Ideal for Daily Pooja, Meditation, Yoga & Spiritual Practices",
    "Promotes Refreshing Atmosphere, Peace & Positive Energy",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala",
  ],

  packing: [
    "75gm - MRP ₹80/-",
    "250gm - MRP ₹200/-",
  ],

  usage:
    "Suitable for Swami Samarth Devotion, Daily Pooja, Meditation, Yoga, Spiritual Practices, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the divine Powdery Floral aroma of Lily, Jasmine & Rose show you the path to peace and devotion.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: swami1,
  imgs: [swami1, swami2, swami3],
},



{
  id: "narayani-flora-agarbatti",
  name: "Narayani Flora - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Rosy Flora",
  scent: "Rose, Floral, Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "75g", mrp: "₹80" },
    { size: "250g", mrp: "₹200" },
  ],

  shortDesc:
    "Premium natural masala agarbatti with a royal Rosy Flora fragrance — Rose petals used for 5000+ years, giving sweet floral accords always ahead of times.",

  longDesc:
    "PRAKHYAT – NARAYANI FLORA – ROSY FLORA FRAGRANCE. Rose has been used for more than 5000 years as a source of fragrance — its petals giving a royal, sweet floral accords always ahead of times. A must-have perfumery note giving it a special place for Puja, Meditation, Yoga, relieving Stress, bringing Peace and Positive Energy to your living.",

  benefits: [
    "Creates a Pleasant & Royal Rosy Flora Aroma in your surroundings",
    "Rose — used for 5000+ years, a timeless must-have perfumery note",
    "Royal Sweet Floral accords always ahead of times",
    "Ideal for Daily Pooja, Meditation, Yoga & Stress Relief",
    "Brings Peace, Positive Energy & Refreshing Atmosphere",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala",
  ],

  packing: [
    "75gm - MRP ₹80/-",
    "250gm - MRP ₹200/-",
  ],

  usage:
    "Suitable for Daily Pooja, Meditation, Yoga, Stress Relief, Spiritual Practices, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the royal Rosy Flora aroma fill your space with sweetness, peace and positive energy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: narayani1,
  imgs: [narayani1, narayani2, narayani3],
},



{
  id: "hari-krupa-agarbatti",
  name: "Hari Krupa - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Divine Champa",
  weight: ["75g", "250g"],
  burnTime: "1 Hour",

  desc: "Sweet champa fragrance loved in temples.",

  longDesc:
    "Hari Krupa Agarbatti spreads the divine aroma of champa flowers, creating a peaceful and devotional atmosphere. Ideal for temple use, daily pooja, and meditation, it fills your space with calmness, positivity, and spiritual energy.",

  material: "Wood Powder",

  benefits: [
    "Sweet and soothing champa fragrance",
    "Perfect for temple and pooja",
    "Ideal for meditation and relaxation",
    "Creates peaceful and positive environment"
  ],

  flipkartUrl: "#",

  img: hare1,
  imgs: [hare1, hare2, hare3],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala"
  ]
},





{
  id: "hare-krishna-agarbatti",
  name: "Hare Krishna - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Leafy Green",
  scent: "Natural Green, Basil, Betel Leaf, Strong Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "75g", mrp: "₹80" },
    { size: "250g", mrp: "₹200" },
  ],

  shortDesc:
    "Premium natural masala agarbatti with a strong Leafy Green fragrance — takes you on a green journey of leafy hay forest with Basil & Betel Leaf notes for deep relaxation.",

  longDesc:
    "PRAKHYAT – HARE KRISHNA – LEAFY GREEN FRAGRANCE. A strong, powerful aroma taking you to a Green Journey of leafy hay forest — just like smelling a bunch of crushed leaves with abundance of freshness. Also giving a Basil or Betel Leaf smell — a very good relaxing note which reduces stress, making it a favourite among customers.",

  benefits: [
    "Creates a Strong & Powerful Leafy Green Aroma in your surroundings",
    "Takes you on a Green Journey — freshness of crushed leaves, hay & forest",
    "Unique Basil & Betel Leaf notes — a favourite relaxing fragrance among customers",
    "Ideal for Stress Relief, Relaxation, Daily Pooja & Meditation",
    "Promotes Refreshing Atmosphere, Peace & Positive Energy",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala",
  ],

  packing: [
    "75gm - MRP ₹80/-",
    "250gm - MRP ₹200/-",
  ],

  usage:
    "Suitable for Stress Relief, Relaxation, Daily Pooja, Meditation, Yoga, Spiritual Practices, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the strong Leafy Green aroma take you on a fresh green journey of calm and relaxation.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: krishna1,
  imgs: [krishna1, krishna2, krishna3],
},

{
  id: "swagat-agarbatti",
  name: "Swagat - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Fancy Perfume Note",
  scent: "Fancy, Fruity, Resin, Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",
  itemLength: "23 cm",

  weight: [
    { size: "75g", mrp: "₹80" },
    { size: "250g", mrp: "₹200" },
  ],

  shortDesc:
    "Premium natural masala agarbatti with a modern Fancy Perfume note — smooth Fruits, Flowers & Resin combination that spreads easily in larger areas with a long lasting impression.",

  longDesc:
    "PRAKHYAT – SWAGAT – PERFUME WITH FANCY NOTE. SWAGAT Masala Agarbatti is a modern perfume type with fancy smell, keeping the traditional fragrance alive — smooth aroma like some Fruits on Flowers & Resins combination, easy to spread in larger areas and giving a long lasting impression. Throwing a peppy note to enhance moods, Meditation, increase concentration — a perfect aroma for Puja and Devotional time.",

  benefits: [
    "Creates a Pleasant & Modern Fancy Perfume Aroma in your surroundings",
    "Smooth blend of Fruits, Flowers & Resins — easy to spread in larger areas",
    "Peppy note that enhances Mood, increases Concentration & uplifts Energy",
    "Perfect aroma for Puja, Devotional time, Meditation & Yoga",
    "Modern Perfume type — keeps traditional fragrance alive with a long lasting impression",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala",
  ],

  packing: [
    "75gm - MRP ₹80/-",
    "250gm - MRP ₹200/-",
  ],

  usage:
    "Suitable for Daily Pooja, Devotional Time, Meditation, Yoga, Mood Enhancement, and Home & Office Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the modern Fancy Perfume aroma spread its peppy note and fill your space with positivity and devotion.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: swagat1,
  imgs: [swagat1, swagat2, swagat3],
},

{
  id: "ashish-agarbatti",
  name: "Ashish - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Blessing Sandal",
  weight: ["75g", "250g"],
  burnTime: "1 Hour",

  desc: "Peaceful sandal fragrance symbolizing blessings.",

  longDesc:
    "Ashish Agarbatti spreads a soft and calming sandalwood fragrance that symbolizes blessings and positivity. Ideal for pooja, meditation, and daily rituals, it creates a peaceful and devotional atmosphere filled with spiritual calmness.",

  material: "Wood Powder",

  benefits: [
    "Soft sandalwood fragrance",
    "Perfect for pooja and rituals",
    "Ideal for meditation and relaxation",
    "Creates peaceful devotional environment"
  ],

  flipkartUrl: "#",

  img: ashish1,
  imgs: [ashish1, ashish2, ashish3],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala"
  ]
},

{
  id: "anmol-sugandh-agarbatti",
  name: "Anmol Sugandh - Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Premium",
  fragrance: "Premium Floral Blend",
  weight: ["100g", "250g"],
  burnTime: "1 Hour",

  desc: "Rich premium floral fragrance.",

  longDesc:
    "Anmol Sugandh Agarbatti spreads a luxurious blend of premium floral fragrances, creating a rich and divine atmosphere. Perfect for pooja, meditation, and daily rituals, it fills your surroundings with elegance, freshness, and long-lasting positivity.",

  material: "Wood Powder",

  benefits: [
    "Luxurious floral fragrance blend",
    "Perfect for pooja and rituals",
    "Ideal for meditation and relaxation",
    "Creates elegant and positive atmosphere"
  ],

  flipkartUrl: "#",

  img: anmol1,
  imgs: [anmol1, anmol2, anmol3],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Premium Masala"
  ]
},


// {
//   id: "anmol-flora-agarbatti",
//   name: "Anmol Flora - Extra Premium Masala Agarbattis",
//   type: "Agarbatti",
//   tier: "Extra Premium",
//   fragrance: "Fresh Garden Flowers",
//   scent: "Floral Accords, Amber Wood, Rose, Jasmine, Pure Natural Masala Type",
//   material: "Wood Powder",
//   duration: "1 Hour",

//   weight: [
//     { size: "50g", mrp: "₹--" },
//     { size: "250g", mrp: "₹--" },
//   ],

//   shortDesc:
//     "Extra Premium natural masala agarbatti with classic Floral fragrance — Amber Wood, Rose & Jasmine blend creates a beautiful lingering aroma that fills your space with freshness and positivity.",

//   longDesc:
//     "PRAKHYAT – ANMOL FLORA – Special Crafted Extra Premium Natural Masala Agarbatti made from classic Amber Wood, Rose & Jasmine Perfume. Made from pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Gives a floral accord with Amber Wood and Rose Flower aroma with a lingering effect in surroundings, creating a pleasant atmosphere. Spreads fragrance quickly in large spaces — one can feel the existence of a fresh flower bouquet blooming in your living space.",

//   benefits: [
//     "Floral Accords of Amber Wood, Rose & Jasmine — beautiful, lingering fragrance",
//     "Feels like a fresh flower bouquet blooming in your living space",
//     "Spreads fragrance quickly in large spaces — creates pleasant atmosphere",
//     "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
//     "Perfect for Meditation, Yoga, Aromatherapy & Garden Fragrance",
//     "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
//   ],

//   highlights: [
//     "100% Natural",
//     "No Charcoal",
//     "Handcrafted",
//     "Extra Premium Masala",
//   ],

//   packing: [
//     "50gm - MRP ₹--/-",
//     "250gm - MRP ₹--/-",
//   ],

//   usage:
//     "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

//   howToUse: [
//     "Place the agarbatti in a suitable incense holder or stand.",
//     "Light the tip and allow it to flame for 5–10 seconds.",
//     "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
//     "Place the holder in a safe, well-ventilated area away from flammables.",
//     "Let the beautiful Floral & Amber Wood aroma fill your space with freshness and positive energy.",
//     "Never leave burning incense unattended.",
//   ],

//   safety:
//     "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

//   flipkartUrl: "#",

//   img: anmolflora1,
//   imgs: [anmolflora1],
// },
{
  id: "anmol-flora-agarbatti",
  name: "Anmol Flora - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Fresh Garden Flowers",
  scent: "Floral Accords, Amber Wood, Rose, Jasmine, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with classic Floral fragrance — Amber Wood, Rose & Jasmine blend creates a beautiful lingering aroma that fills your space with freshness and positivity.",

  longDesc:
    "PRAKHYAT – ANMOL FLORA – Special Crafted Extra Premium Natural Masala Agarbatti made from classic Amber Wood, Rose & Jasmine Perfume. Made from pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Gives a floral accord with Amber Wood and Rose Flower aroma with a lingering effect in surroundings, creating a pleasant atmosphere. Spreads fragrance quickly in large spaces — one can feel the existence of a fresh flower bouquet blooming in your living space.",

  benefits: [
    "Floral Accords of Amber Wood, Rose & Jasmine — beautiful, lingering fragrance",
    "Feels like a fresh flower bouquet blooming in your living space",
    "Spreads fragrance quickly in large spaces — creates pleasant atmosphere",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the beautiful Floral & Amber Wood aroma fill your space with freshness and positive energy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: anmolflora1,
  imgs: [anmolflora1],
},

{
  id: "anmol-nagchampa-agarbatti",
  name: "Anmol Nagchampa - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Classic Nagchampa",
  scent: "Nagchampa Flower, Floral Accords, Flowery Spicy Powdery Note, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with classic Nagchampa fragrance — Flowery, Spicy & Powdery notes create an exquisite, lingering aroma loved in temples since ages.",

  longDesc:
    "PRAKHYAT – ANMOL NAGCHAMPA – Unique Crafted Extra Premium Natural Masala Agarbatti made from high-class Nagchampa Perfume giving an exquisite aroma in surroundings. One of the favourite masala agarbattis since ages with a Flowery, Spicy & Powdery note. Made from pure quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — ruling in the fragrance industry since ages. Gives a real reminiscence of Nagchampa Flower aroma with a lingering effect, creating a pleasant atmosphere and quickly spreading fragrance across large spaces.",

  benefits: [
    "Classic Nagchampa aroma — Flowery, Spicy & Powdery notes loved since ages",
    "Spreads fragrance quickly in large spaces with a beautiful lingering effect",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress, Brings Peace and Positive Energy to your living",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the classic Nagchampa aroma fill your space with devotion and calm.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: nagchampa1,
  imgs: [nagchampa1, nagchampa2],
},
{
  id: "sai-heaven-agarbatti",
  name: "Sai Heaven - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Divine Mogra",
  weight: ["50g", "250g"],
  burnTime: "50 Min",

  desc: "Soft mogra fragrance creating heavenly ambiance.",

  longDesc:
    "Sai Heaven Agarbatti fills your surroundings with a soothing mogra fragrance, creating a divine and peaceful ambiance. Ideal for Sai devotion, pooja, and meditation, it brings calmness, positivity, and spiritual harmony.",

  material: "Wood Powder",

  benefits: [
    "Soothing mogra fragrance",
    "Perfect for Sai devotion and pooja",
    "Ideal for meditation and relaxation",
    "Creates calm and divine atmosphere"
  ],

  flipkartUrl: "#",

  img: sai01,
  imgs: [sai01],

  highlights: [
    "100% Natural",
    "Masala Blend",
    "Long Burning",
    "Temple Fragrance"
  ]
},
{
  id: "anmol-chandan-agarbatti",
  name: "Anmol Chandan - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Pure Sandalwood",
  scent: "Mysore Sandalwood Resemblance, Creamy, Warm, Powdery, Traditional Notes, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with Mysore Sandalwood fragrance — Creamy, Warm & Powdery notes with traditional richness create a calm, sacred & deeply peaceful atmosphere.",

  longDesc:
    "PRAKHYAT – ANMOL CHANDAN – Unique Crafted Extra Premium Natural Masala Agarbatti made from Mysore Sandal Perfume releasing a creamy, warm and powdery aroma holding traditional notes with its unique presence. Made from pure high-quality ingredients — Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Gives an original Sandalwood resemblance of warmth and richness with a lingering effect in surroundings, creating a calm and peaceful atmosphere. Spreads fragrance quickly in large spaces — one can feel the existence of real Sandalwood used on special occasions.",

  benefits: [
    "Mysore Sandalwood aroma — Creamy, Warm & Powdery with traditional richness",
    "Original Sandalwood resemblance — warmth and richness with lingering effect",
    "Spreads fragrance quickly in large spaces — creates calm & peaceful atmosphere",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Stress Relief",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the warm Mysore Sandalwood aroma fill your space with calm, peace and positive energy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: anmolchandan1,
  imgs: [anmolchandan1],
},

{
  id: "shri-satya-narayan-agarbatti",
  name: "Shri Satya Narayan - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Sacred Temple Blend",
  scent: "Natural Guggal, Frankincense, Flowers, Resinoid, Oriental Notes, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti derived from Natural Guggal, Frankincense & Resinoid — an Oriental fragrance unmatched for its uniqueness and deep holding, ideal for Satyanarayan Puja & sacred rituals.",

  longDesc:
    "PRAKHYAT – SATYA NARAYAN – Unique Crafted Extra Premium Natural Masala Agarbatti derived from resins of Natural Guggal, Frankincense, Flowers & Resinoid — all giving an Oriental type of fragrance unmatched for its uniqueness and deep holding. Made from selected, pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Gives a natural Guggal mix of resins with a lingering effect in surroundings, creating a pleasant and sacred atmosphere and quickly spreading fragrance across large spaces.",

  benefits: [
    "Natural Guggal, Frankincense & Resinoid — Oriental fragrance unmatched in uniqueness",
    "Deep holding sacred aroma — ideal for Satyanarayan Puja, Havan & special rituals",
    "Spreads fragrance quickly in large spaces with a beautiful lingering effect",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Stress Relief",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Satyanarayan Puja, Big Festivals, Havan, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the sacred Guggal & Frankincense aroma fill your space with divinity and positive energy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: satyanarayan1,
  imgs: [satyanarayan1, satyanarayan2, satyanarayan3],
},

{
  id: "shri-satya-vinayak-agarbatti",
  name: "Shri Satya Vinayak - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Ganesh Floral Blend",
  scent: "Strong Lavender, Floral Powdery, Caramel Notes, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with a strong Lavender & Floral Powdery Caramel fragrance — extremely popular and a must-have in every household for daily pooja, festivals and relaxation.",

  longDesc:
    "PRAKHYAT – SATYAVINAYAK – Special Crafted Extra Premium Natural Masala Agarbatti with a strong flowery powdery caramel type fragrance — a reminiscence of Lavender. Extremely popular and a must-have product in every household. Made from selected, pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Gives a strong smell of Lavender with floral powdery notes and a lingering effect in surroundings, creating a pleasant atmosphere and quickly spreading fragrance across large spaces.",

  benefits: [
    "Strong Lavender with Floral Powdery Caramel notes — extremely popular must-have fragrance",
    "Reminiscence of Lavender — beautiful lingering effect loved in every household",
    "Spreads fragrance quickly in large spaces — creates pleasant atmosphere",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Stress Relief",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the strong Lavender & Floral aroma fill your space with freshness and positive energy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: satya1,
  imgs: [satya1, satya2, satya3],
},

{
  id: "govardhan-agarbatti",
  name: "Govardhan - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Krishna Tulsi",
  scent: "Natural Mix Flower Bouquet, Diffusive Strong Aroma, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with a diffusive strong Mix Flower fragrance — a blend of natural flowers known for its long-lasting aroma that fills every corner with freshness and positivity.",

  longDesc:
    "PRAKHYAT – GOVARDHAN – Special Crafted Extra Premium Natural Masala Agarbatti giving a diffusive strong aroma showing its presence everywhere — a Mix Flower blending perfume known for its long-lasting fragrance. Made from selected, pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Gives a natural Mix Flower aroma with a lingering effect in surroundings, creating a pleasant atmosphere and quickly spreading fragrance across large spaces — one can feel the existence of a fresh flower bouquet all around.",

  benefits: [
    "Diffusive strong Mix Flower Bouquet aroma — fills every corner with freshness",
    "Natural flower blending perfume known for its long-lasting lingering fragrance",
    "Spreads fragrance quickly in large spaces — creates pleasant atmosphere",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the natural Mix Flower aroma fill your space with freshness and positive energy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: govardhan1,
  imgs: [govardhan1, govardhan2, govardhan3],
},
{
  id: "aadishakti-flora-agarbatti",
  name: "Aadishakti Flora - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Divine Floral Mix",
  scent: "Smooth Jasmine Flower, Powdery Note, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with a smooth Jasmine Flower fragrance — Arabic Jasmine with a powdery note beneath creates an intense, sensual & divine atmosphere.",

  longDesc:
    "PRAKHYAT – AADI SHAKTI FLORA – Special Crafted Extra Premium Natural Masala Agarbatti. Arabic Jasmine Fragrance with a powdery note beneath its complex aroma makes the environment intense and sensual. Made from selected, pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Spreads a smooth fragrance of Jasmine Flower with a lingering effect in the surrounding area, creating a pleasant atmosphere and quickly filling large spaces with divine fragrance.",

  benefits: [
    "Smooth Jasmine Flower aroma with a powdery, lingering effect in surroundings",
    "Spreads fragrance quickly in large spaces — creates intense & sensual atmosphere",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress, Brings Peace and Positive Energy to your living",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the smooth Jasmine aroma fill your space with divine fragrance and calm.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: adishakti1,
  imgs: [adishakti1, adishakti2],
},





{
  id: "anmol-oudh-agarbatti",
  name: "Anmol Oudh - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Royal Oudh",
  scent: "Strong Oudh, Vetiver, Smoky, Woody, Pungent, Sandal Notes, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with a strong Royal Oudh fragrance — aged & matured Oudh layered with Smoky, Woody, Sandal & Vetiver notes to mesmerise and deeply relax.",

  longDesc:
    "PRAKHYAT – ANMOL OUDH – Unique Crafted Extra Premium Natural Masala Agarbatti made from selected Oudh perfume — aged and matured enough to give a signature note layered with different types of Smoky, Woody, Pungent, Sandal & Vetiver aromas that leave one mesmerised and relaxed. Made from pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Spreads strong Oudh, Vetiver & Smoky fragrance with a lingering effect, creating a pleasant atmosphere and quickly filling large spaces with a rich, royal aroma.",

  benefits: [
    "Strong Oudh fragrance layered with Smoky, Woody, Sandal & Vetiver notes",
    "Aged & matured Oudh — signature aroma that mesmerises and deeply relaxes",
    "Spreads fragrance quickly in large spaces with a beautiful lingering effect",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Stress Relief",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the rich Royal Oudh aroma fill your space with luxury, calm and positive energy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: anmoloudh1,
  imgs: [anmoloudh1, anmoloudh2],
},






{
  id: "kashmiri-kastoori-agarbatti",
  name: "Kashmiri Kastoori - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Kastoori Musk",
  scent: "Strong Kastoori Musk, Undercurrent Flowery Notes, Natural Resins, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with strong Kashmiri Kastoori fragrance — vibrant Musky note with undercurrent Flowery notes blended with natural resins creates a high-grade, lingering aroma.",

  longDesc:
    "PRAKHYAT – KASHMIRI KASTOORI – Unique Crafted Extra Premium Natural Masala Agarbatti with a strong, vibrant Musky note with undercurrent Flowery notes blended with natural resins giving a high-grade fragrance. Made from selected, pure high-quality ingredients — Resins, Flower Powders, Wood Powders, Natural Oils & Ailanthus Malabarica — giving a very good long-lasting aroma. Gives a resemblance of strong Kastoori fragrance with a floral background and a lingering effect in surroundings, creating a pleasant atmosphere and quickly spreading fragrance across large spaces.",

  benefits: [
    "Strong Kastoori Musk with undercurrent Flowery notes — high-grade vibrant fragrance",
    "Natural resins blended aroma — real Kastoori resemblance with floral background",
    "Spreads fragrance quickly in large spaces with a beautiful lingering effect",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Stress Relief",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the strong Kastoori Musk aroma fill your space with warmth and positive energy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: kasturi01,
  imgs: [kasturi01, kasturi02],
},

{
  id: "sadhguru-agarbatti",
  name: "Sadhguru - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Meditation Herbs",
  scent: "Heena Fragrance, Floral Accords, Woody, Saffron, Sandal, Amber Notes, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with a rich Heena fragrance — a well-matured blend of Woody, Saffron, Sandal, Flower & Amber notes highly liked and preserved by classy people.",

  longDesc:
    "PRAKHYAT – SADHGURU – Unique Crafted Extra Premium Natural Masala Agarbatti featuring a Heena fragrance — a mix of different fragrances like Woody, Saffron, Sandal, Flower & Amber, well blended and quite matured to arrive at its natural note. Highly liked and preserved by classy people. Made from selected, pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Gives Heena fragrance with floral accords and a lingering effect in surroundings, creating a pleasant atmosphere and quickly spreading fragrance across large spaces.",

  benefits: [
    "Rich Heena fragrance — well-matured blend of Woody, Saffron, Sandal, Flower & Amber",
    "Highly liked and preserved by classy people for its unique natural note",
    "Spreads fragrance quickly in large spaces with a beautiful lingering effect",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Stress Relief",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the rich Heena & Floral aroma fill your space with calm, focus and positive energy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: sadguru001,
  imgs: [sadguru001, sadguru002],
},

{
  id: "richwoods-agarbatti",
  name: "Richwoods - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Luxury Woody",
  scent: "Woody Forest, Creamy Amber, Earthy Notes, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with a deep Woody Forest fragrance — Creamy Amber & Earthy notes create a classy, rich aroma just like being in a deep forest that lingers for hours and leaves you wanting more.",

  longDesc:
    "PRAKHYAT – RICHWOODS – Unique Crafted Extra Premium Natural Masala Agarbatti presenting a woody, creamy amber and earthy fragrance — just like being in a deep forest. Its classy and rich aroma lingers and lasts for hours, leaving you wanting more. Made from selected, pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Gives a smooth and lasting woody forest fragrance with a lingering effect in surroundings, creating a pleasant atmosphere and quickly spreading fragrance across large spaces.",

  benefits: [
    "Woody Forest aroma with Creamy Amber & Earthy notes — just like a deep forest",
    "Classy and rich fragrance that lingers for hours and leaves you wanting more",
    "Spreads fragrance quickly in large spaces with a beautiful lingering effect",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Stress Relief",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the rich Woody Forest aroma transport you to a deep forest of calm and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: richwoods1,
  imgs: [richwoods1],
},

{
  id: "shristhi-agarbatti",
  name: "Shristhi - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Nature Blossom",
  weight: ["50g", "250g"],
  burnTime: "1 Hour",

  desc: "Refreshing nature inspired fragrance.",

  longDesc:
    "Shristhi Agarbatti spreads a refreshing aroma inspired by nature and fresh blossoms. Ideal for pooja, meditation, and relaxation, it creates a calm, natural, and soothing environment filled with freshness and positivity.",

  material: "Wood Powder",

  benefits: [
    "Refreshing natural floral fragrance",
    "Perfect for relaxation and meditation",
    "Ideal for daily pooja",
    "Creates calm and soothing environment"
  ],

  flipkartUrl: "#",

  img: shristhi11,
  imgs: [shristhi11, shristhi12,],

  highlights: [
    "100% Natural",
    "Masala Blend",
    "Long Burning",
    "Temple Fragrance"
  ]
},

{
  id: "sanatan-agarbatti",
  name: "Sanatan - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Ancient Temple Aroma",
  weight: ["50g", "250g"],
  burnTime: "50 Min",

  desc: "Traditional fragrance used in temples.",

  longDesc:
    "Sanatan Agarbatti spreads a timeless spiritual fragrance inspired by ancient temple rituals. Ideal for pooja, meditation, and daily devotion, it creates a sacred and peaceful environment filled with positivity and divine energy.",

  material: "Wood Powder",

  benefits: [
    "Traditional temple fragrance",
    "Perfect for pooja and rituals",
    "Ideal for meditation and devotion",
    "Creates sacred and peaceful atmosphere"
  ],

  flipkartUrl: "#",

  img: sanatan1,
  imgs: [sanatan1, sanatan2],

  highlights: [
    "100% Natural",
    "Masala Blend",
    "Long Burning",
    "Temple Fragrance"
  ]
},

{
  id: "kesar-chandan-agarbatti",
  name: "Kesar Chandan - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Kesar Sandalwood",
  scent: "Saffron (Kesar), Sandalwood (Chandan), Sharp, Spicy, Woody, Oriental Notes, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with a fusion of Saffron & Sandalwood — Sharp, Spicy, Woody & Oriental notes create a stage-like performance that lifts mood and feels like a walk through a woody forest.",

  longDesc:
    "PRAKHYAT – KESAR CHANDAN – Unique Crafted Extra Premium Natural Masala Agarbatti — a fusion fragrance of Saffron (Kesar) and Sandalwood (Chandan), a distinctive combination that fills spaces with sharp, spicy, woody & oriental notes giving it a special stage-like performance. Lifts mood and feels like travelling through a wood forest area. Made from selected, pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Spreads Saffron & Sandal fragrance with a lingering effect in surroundings, creating a pleasant atmosphere and quickly filling large spaces.",

  benefits: [
    "Fusion of Saffron & Sandalwood — Sharp, Spicy, Woody & Oriental notes",
    "Stage-like performance aroma — lifts mood, feels like walking through a forest",
    "Spreads fragrance quickly in large spaces with a beautiful lingering effect",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Stress Relief",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the rich Saffron & Sandalwood aroma lift your mood and fill your space with warmth and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: kesar1,
  imgs: [kesar1, kesar2, kesar3],
},

{
  id: "paradise-agarbatti",
  name: "Paradise - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Heavenly Floral",
  scent: "Fresh Vanilla, Floral Accords, Soothing Powdery Note, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with a significant blend of Vanilla & Flora — soothing, rich & powdery notes throw aroma to far distances, putting everyone in a comfort zone that lasts forever.",

  longDesc:
    "PRAKHYAT – PARADISE – Unique Crafted Extra Premium Natural Masala Agarbatti — a significant blend of Vanilla and Flora throwing its aroma to far distances. A soothing richness with a powdery note that puts everyone in a comfort zone and lasts in their mind forever. Made from selected, pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Gives fresh Vanilla and Floral aroma with a lingering effect in surroundings, creating a pleasant atmosphere and quickly spreading fragrance across large spaces.",

  benefits: [
    "Significant Vanilla & Flora blend — soothing powdery richness that lingers in memory",
    "Throws aroma to far distances — puts everyone in a lasting comfort zone",
    "Spreads fragrance quickly in large spaces with a beautiful lingering effect",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Stress Relief",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the heavenly Vanilla & Flora aroma put you in a comfort zone of calm and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: paradise1,
  imgs: [paradise1, paradise2, paradise3],
},

{
  id: "seven-heaven-agarbatti",
  name: "Seven Heaven - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Mystic Floral Blend",
  weight: ["50g", "250g"],
  burnTime: "50 Min",

  desc: "Mystical fragrance inspired by heavenly gardens.",

  longDesc:
    "Seven Heaven Agarbatti spreads a magical and soothing floral aroma inspired by heavenly gardens. Ideal for meditation, pooja, and relaxation, it creates a serene and refreshing environment filled with calmness and positivity.",

  material: "Wood Powder",

  benefits: [
    "Mystic and soothing floral fragrance",
    "Perfect for meditation and relaxation",
    "Creates calm and peaceful environment",
    "Enhances spiritual ambiance"
  ],

  flipkartUrl: "#",

  img: seven1,
  imgs: [seven1, seven2, seven3],

  highlights: [
    "100% Natural",
    "Masala Blend",
    "Long Burning",
    "Temple Fragrance"
  ]
},

{
  id: "vibhuthi-agarbatti",
  name: "Vibhuthi - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Sacred Ash Aroma",
  scent: "Authentic Oriental Green Leafy Fragrance, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti with an authentic Oriental Green Leafy fragrance — traditionally used in Indian temples and worship places to create calmness, peace and tranquility at home and office.",

  longDesc:
    "PRAKHYAT – VIBHUTI – Unique Crafted Extra Premium Natural Masala Agarbatti — a blend of authentic and Oriental Green Leafy fragrance traditionally used by Indian temples and worship places. Creates calmness, peace and tranquility at one's home, office and sacred spaces. Made from selected, pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Gives an Oriental Green Leafy aroma with a lingering effect in surroundings, creating a pleasant atmosphere and quickly spreading fragrance across large spaces.",

  benefits: [
    "Authentic Oriental Green Leafy fragrance — traditionally used in Indian temples",
    "Creates calmness, peace and tranquility at home, office and sacred spaces",
    "Spreads fragrance quickly in large spaces with a beautiful lingering effect",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Stress Relief",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the authentic Oriental Green Leafy aroma fill your space with temple-like calm and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: vibhuti1,
  imgs: [vibhuti1, vibhuti2],
},

{
  id: "vrindavan-agarbatti",
  name: "Vrindavan - Extra Premium Masala Agarbattis",
  type: "Agarbatti",
  tier: "Extra Premium",
  fragrance: "Vrindavan Flowers",
  scent: "Fresh Green Leafy, Flower Mist, Green Grassy, Rose & Jasmine Bouquet, Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "1 Hour",

  weight: [
    { size: "50g", mrp: "₹--" },
    { size: "250g", mrp: "₹--" },
  ],

  shortDesc:
    "Extra Premium natural masala agarbatti specially developed with freshness of garden, flower mist & Green Grassy notes — Rose & Jasmine flower bouquets create a divine Vrindavan-like aroma of peace and devotion.",

  longDesc:
    "PRAKHYAT – VRINDAVAN – Unique Crafted Extra Premium Natural Masala Agarbatti specially developed with an aroma filled with freshness of garden, flower mist, Green Grassy notes with Rose and Jasmine flower bouquets. Made from selected, pure high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — giving a very good long-lasting aroma. Gives fresh Green Leafy aroma with a lingering effect in surroundings, creating a pleasant atmosphere and quickly spreading fragrance across large spaces — one can feel the divine freshness of the holy land of Vrindavan.",

  benefits: [
    "Fresh Green Leafy aroma with Flower Mist, Rose & Jasmine — divine Vrindavan freshness",
    "Garden freshness with Green Grassy notes — feels like walking through a flower bouquet",
    "Spreads fragrance quickly in large spaces with a beautiful lingering effect",
    "Ideal for Daily Pooja, Big Festivals like Ganesh Chaturthi, Dussehra & Diwali",
    "Perfect for Meditation, Yoga, Aromatherapy & Stress Relief",
    "Long-lasting 1 Hour fragrance with 100% Natural ingredients",
  ],

  highlights: [
    "100% Natural",
    "No Charcoal",
    "Handcrafted",
    "Extra Premium Masala",
  ],

  packing: [
    "50gm - MRP ₹--/-",
    "250gm - MRP ₹--/-",
  ],

  usage:
    "Suitable for Daily Pooja, Big Festivals, Havan, Satyanarayan Puja, Meditation, Yoga, Aromatherapy, Stress Relief, and Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the fresh Rose, Jasmine & Green Leafy aroma fill your space with divine Vrindavan energy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: vrindavan1,
  imgs: [vrindavan1, vrindavan2],
},



{
  id: "chandan-van-agarbatti",
  name: "Prakhyat Chandan Van Premium Scented Agarbatti",
  type: "Agarbatti",
  tier: "Scented",
  fragrance: "Chandan Van — Deep Forest Sandalwood",
  scent: "Warm, Classy, Spicy & Powdery Sandalwood Undertones",
  material: "Wood Powder",
  charcoalFree: true,
  duration: "20 to 30 Min",
  itemLength: "23 centimeters",

  weight: [
    { size: "100g", mrp: "₹__" },
  ],

  shortDesc:
    "Premium Scented Chandan Van Agarbatti with Deep Forest Sandalwood fragrance — warm, classy notes inspired by wood logs rubbed against stones, releasing a spicy warm powdery undertone that fills your space with natural calm and spirituality.",

  longDesc:
    "PRAKHYAT – PREMIUM SCENTED CHANDAN VAN AGARBATTI — CHANDAN VAN comes from deep forest sandalwoods known for their warm classy notes. Like wood logs rubbed against stones, it throws a different aroma — similar to a spicy warm powdery undertone that is uniquely natural and deeply calming. Charcoal Free Scented Agarbatti made from Wood Powders, giving a lasting aroma that creates a pleasant atmosphere in your living space. Ideal for Daily Worship, Pooja, Meditation, Yoga, Stress Relief, and bringing Peace and Positive Energy to your life.",

  benefits: [
    "Spreads Deep Forest Sandalwood Fragrance — Warm, Classy & Spicy Powdery Notes",
    "Inspired by wood logs rubbed against stones — a uniquely natural aroma",
    "Charcoal Free formula — cleaner and healthier burning experience",
    "Warm classy sandalwood notes from deep forest sandalwoods",
    "Ideal for Pooja, Meditation, Yoga & Daily Spiritual Rituals",
    "Creates a Pleasant, Calm & Natural Atmosphere in your living space",
    "Brings Peace, Positivity & Natural Forest Energy to your surroundings",
  ],

  highlights: [
    "Deep Forest Sandalwood",
    "Charcoal Free",
    "Long Lasting Aroma",
    "Premium Scented",
  ],

  packing: [
    "100g",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the warm Deep Forest Sandalwood aroma fill your space with natural calm and positive energy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: chandan1,
  imgs: [chandan1, chandan2],
},
{
  id: "black-n-berry-agarbatti",
  name: "Prakhyat Black N Berry Premium Scented Agarbatti",
  type: "Agarbatti",
  tier: "Scented",
  fragrance: "Black N Berry — Fancy Fruity & Cypher Blend",
  scent: "Strong Fancy, Fruity, Cypher & Fresh Fruit Basket",
  material: "Wood Powder",
  charcoalFree: true,
  duration: "20 to 30 Min",
  itemLength: "23 centimeters",

  weight: [
    { size: "100g", mrp: "₹__" },
  ],

  shortDesc:
    "Premium Scented Black N Berry Agarbatti with a strong fancy Fruity & Cypher combination — makes your home and office smell like a fresh fruit basket with a lingering soothing note that is modern, lively and refreshing.",

  longDesc:
    "PRAKHYAT – PREMIUM SCENTED BLACK N BERRY AGARBATTI — BLACK N BERRY brings a strong fancy fragrance with a Cypher and Fruity combination that makes your home and office smell like a fresh fruit basket, lingering a soothing note throughout your space. Charcoal Free Scented Agarbatti made from Wood Powders, giving a lasting aroma that creates a pleasant atmosphere in your living space. Ideal for Daily Worship, Pooja, Meditation, Yoga, Stress Relief, and bringing Peace and Positive Energy to your life.",

  benefits: [
    "Spreads Strong Fancy Fruity & Cypher Fragrance — Fresh Fruit Basket Aroma",
    "Makes your home and office smell like a fresh fruit basket",
    "Lingers a soothing note throughout your space",
    "Charcoal Free formula — cleaner and healthier burning experience",
    "Ideal for Pooja, Meditation, Yoga & Daily Use",
    "Creates a Pleasant, Fresh & Lively Atmosphere in your living space",
    "Brings Positivity, Freshness & Positive Energy to your surroundings",
  ],

  highlights: [
    "Fruity & Cypher Blend",
    "Charcoal Free",
    "Long Lasting Aroma",
    "Premium Scented",
  ],

  packing: [
    "100g",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Home & Office Fragrance, Stress Relief & Refreshing Atmosphere.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the strong fancy Black N Berry aroma fill your home and office with freshness and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: berry1,
  imgs: [berry1, berry2],
},

{
  id: "royal-sweden-agarbatti",
  name: "Prakhyat Sweden Premium Scented Agarbatti",
  type: "Agarbatti",
  tier: "Scented",
  fragrance: "Sweden — Strong Lavender Mix of Flowers",
  scent: "Strong Lavender, Mixed Florals, Powdery & Green Leafy Notes",
  material: "Wood Powder",
  charcoalFree: true,
  duration: "20 to 30 Min",
  itemLength: "23 centimeters",

  weight: [
    { size: "100g", mrp: "₹__" },
  ],

  shortDesc:
    "Premium Scented Sweden Agarbatti with a very strong Lavender Mix of Flowers — blended with powders and green leafy notes, creating a distinct and outstanding aroma that is refreshing, elegant and truly unique.",

  longDesc:
    "PRAKHYAT – PREMIUM SCENTED SWEDEN AGARBATTI — SWEDEN brings a very strong Lavender Mix of Flowers together, added with powders and green leafy notes, making it a distinct and outstanding aroma in its league. Charcoal Free Scented Agarbatti made from Wood Powders, giving a lasting aroma that creates a pleasant atmosphere in your living space. Ideal for Daily Worship, Pooja, Meditation, Yoga, Stress Relief, and bringing Peace and Positive Energy to your life.",

  benefits: [
    "Spreads Very Strong Lavender Mix — Mixed Florals, Powdery & Green Leafy Notes",
    "Distinct and outstanding aroma that stands apart in its league",
    "Unique blend of Lavender, Mixed Flowers & Green Leafy notes together",
    "Charcoal Free formula — cleaner and healthier burning experience",
    "Ideal for Pooja, Meditation, Yoga & Daily Spiritual Rituals",
    "Creates a Pleasant, Fresh & Elegant Atmosphere in your living space",
    "Brings Peace, Freshness & Positive Energy to your surroundings",
  ],

  highlights: [
    "Strong Lavender Mix",
    "Charcoal Free",
    "Long Lasting Aroma",
    "Premium Scented",
  ],

  packing: [
    "100g",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Stress Relief, Aromatherapy & Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the strong Lavender Mix of Flowers and green leafy notes fill your space with freshness and positive energy.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: sweden1,
  imgs: [sweden1, sweden2],
},
{
  id: "garden-rose-agarbatti",
  name: "Prakhyat Garden Rose Premium Scented Agarbatti",
  type: "Agarbatti",
  tier: "Scented",
  fragrance: "Garden Rose — Bulgaria Rose Type",
  scent: "Strong Rose, Fresh Petal Notes & Crushed Rose Perfume",
  material: "Wood Powder",
  charcoalFree: true,
  duration: "20 to 30 Min",
  itemLength: "23 centimeters",

  weight: [
    { size: "100g", mrp: "₹__" },
  ],

  shortDesc:
    "Premium Scented Garden Rose Agarbatti with a strong Bulgaria Rose type fragrance — smells like crushed rose petals dipped in perfume, ideal for every occasion from religious celebrations to daily home worship.",

  longDesc:
    "PRAKHYAT – PREMIUM SCENTED GARDEN ROSE AGARBATTI — A strong rosy fragrance of Bulgaria Rose type that smells like petals of rose crushed and dipped in perfume. Useful in any occasion — from celebration of religious functions at home to daily worship places. Charcoal Free Scented Agarbatti made from Wood Powders, giving a lasting aroma that creates a pleasant atmosphere in your living space. Ideal for Daily Worship, Pooja, Meditation, Yoga, Stress Relief, and bringing Peace and Positive Energy to your life.",

  benefits: [
    "Spreads strong Bulgaria Rose type fragrance — Fresh Rose Petal Notes",
    "Smells like petals of rose crushed and dipped in perfume",
    "Charcoal Free formula — cleaner and healthier burning experience",
    "Useful for every occasion — Religious Functions, Celebrations & Daily Worship",
    "Ideal for Pooja, Meditation, Yoga & Stress Relief",
    "Creates a Pleasant & Refreshing Atmosphere in your living space",
    "Brings Peace, Positivity & Fresh Floral Energy to your surroundings",
  ],

  highlights: [
    "Bulgaria Rose Fragrance",
    "Charcoal Free",
    "Long Lasting Aroma",
    "Premium Scented",
  ],

  packing: [
    "100g",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Religious Functions, Celebrations, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the strong Bulgaria Rose aroma of crushed rose petals fill your space with freshness and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: garden1,
  imgs: [garden1, garden2],
},

{
  id: "wonderful-gardenia-agarbatti",
  name: "Prakhyat Wonderful Premium Scented Agarbatti",
  type: "Agarbatti",
  tier: "Scented",
  fragrance: "Gardenia — French Flowers Type",
  scent: "Fast-Spreading Gardenia, Fresh French Floral Notes & Lingering Aroma",
  material: "Wood Powder",
  charcoalFree: true,
  duration: "20 to 30 Min",
  itemLength: "23 centimeters",

  weight: [
    { size: "100g", mrp: "₹__" },
  ],

  shortDesc:
    "Premium Scented Wonderful Agarbatti with a fast-spreading Gardenia French fragrance — a fresh floral aroma that fills every corner in seconds and lingers for hours, ideal for every occasion from religious celebrations to daily home worship.",

  longDesc:
    "PRAKHYAT – PREMIUM SCENTED WONDERFUL AGARBATTI — A fast and furious type aroma that spreads to every corner in just seconds and lingers for hours. Showcasing a fragrance to be remembered and cherished — like fresh Gardenia French flowers in full bloom. Charcoal Free Scented Agarbatti made from Wood Powders, giving a lasting aroma that creates a pleasant atmosphere in your living space. Ideal for Daily Worship, Pooja, Meditation, Yoga, Stress Relief, and bringing Peace and Positive Energy to your life.",

  benefits: [
    "Fast-spreading Gardenia French fragrance — fills every corner in seconds",
    "Lingers for hours — a fragrance to be remembered and cherished",
    "Fresh French floral aroma like Gardenia flowers in full bloom",
    "Charcoal Free formula — cleaner and healthier burning experience",
    "Useful for every occasion — Religious Functions, Celebrations & Daily Worship",
    "Ideal for Pooja, Meditation, Yoga & Stress Relief",
    "Creates a Pleasant & Refreshing Atmosphere in your living space",
    "Brings Peace, Positivity & Fresh Floral Energy to your surroundings",
  ],

  highlights: [
    "Gardenia French Fragrance",
    "Fast & Furious Spread",
    "Charcoal Free",
    "Long Lasting Aroma",
    "Premium Scented",
  ],

  packing: [
    "100g",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Religious Functions, Celebrations, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the fast-spreading Gardenia French aroma fill every corner of your space with freshness and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: wonderfull1,
  imgs: [wonderfull2,wonderfull3],
},

{
  id: "beautiful-fruits-flowers-agarbatti",
  name: "Prakhyat Beautiful Premium Scented Agarbatti",
  type: "Agarbatti",
  tier: "Scented",
  fragrance: "Fruits, Flowers & Earthy — Nature Blend Type",
  scent: "Strong Fruits, Fresh Flowers & Earthy Notes — A Full Nature Aroma",
  material: "Wood Powder",
  charcoalFree: true,
  duration: "20 to 30 Min",
  itemLength: "23 centimeters",

  weight: [
    { size: "100g", mrp: "₹__" },
  ],

  shortDesc:
    "Premium Scented Beautiful Agarbatti with a strong crazy flow of Fruits, Flowers & Earthy fragrance — transforms your space into a beautiful shrine, removes unwanted odors and brings nature closer to your living.",

  longDesc:
    "PRAKHYAT – PREMIUM SCENTED BEAUTIFUL AGARBATTI — A strong crazy flow of fragrance that transforms any place into a beautiful shrine. A rich blend of Fruits, Flowers & Earthy notes that brings nature to a closer view — removing all types of unwanted odors while brightening and sparkling your living space. Charcoal Free Scented Agarbatti made from Wood Powders, giving a lasting aroma that creates a pleasant atmosphere in your living space. Ideal for Daily Worship, Pooja, Meditation, Yoga, Stress Relief, and bringing Peace and Positive Energy to your life.",

  benefits: [
    "Strong crazy flow of fragrance — transforms any place into a beautiful shrine",
    "Rich blend of Fruits, Flowers & Earthy notes — brings nature to a closer view",
    "Removes all types of unwanted odors from your surroundings",
    "Brightens and sparkles your living space with fresh natural aroma",
    "Charcoal Free formula — cleaner and healthier burning experience",
    "Useful for every occasion — Religious Functions, Celebrations & Daily Worship",
    "Ideal for Pooja, Meditation, Yoga & Stress Relief",
    "Brings Peace, Positivity & Natural Energy to your surroundings",
  ],

  highlights: [
    "Fruits Flowers & Earthy Fragrance",
    "Transforms Space into a Shrine",
    "Removes Unwanted Odors",
    "Charcoal Free",
    "Long Lasting Aroma",
    "Premium Scented",
  ],

  packing: [
    "100g",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Religious Functions, Celebrations, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the strong Fruits, Flowers & Earthy aroma transform your space into a beautiful shrine of nature and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: beautiful1,
  imgs: [beautiful2, beautiful3],
},


// {
//   id: "heena-floral-agarbatti",
//   name: "Prakhyat Heena Premium Scented Agarbatti",
//   type: "Agarbatti",
//   tier: "Scented",
//   fragrance: "Heena — Flowery Accords with Oriental Touch",
//   scent: "Strong Flowery Accords, Oriental Notes & Clean Mesmerizing Aroma",
//   material: "Wood Powder",
//   charcoalFree: true,
//   duration: "20 to 30 Min",
//   itemLength: "23 centimeters",

//   weight: [
//     { size: "100g", mrp: "₹__" },
//   ],

//   shortDesc:
//     "Premium Scented Heena Agarbatti with an unmatched strong aroma of Flowery Accords and an Oriental touch — clean and mesmerizing, takes you to the serenity of nature with every breath.",

//   longDesc:
//     "PRAKHYAT – PREMIUM SCENTED HEENA AGARBATTI — An unmatched strong aroma reminiscent of flowery accords with an oriental touch, delivering a smell that takes you to the serenity of nature — clean and mesmerizing. A fragrance that calms the mind, soothes the soul and creates an atmosphere of pure tranquility around you. Charcoal Free Scented Agarbatti made from Wood Powders, giving a lasting aroma that creates a pleasant atmosphere in your living space. Ideal for Daily Worship, Pooja, Meditation, Yoga, Stress Relief, and bringing Peace and Positive Energy to your life.",

//   benefits: [
//     "Unmatched strong aroma of Flowery Accords with a rich Oriental touch",
//     "Clean and mesmerizing fragrance — takes you to the serenity of nature",
//     "Calms the mind and soothes the soul with every breath",
//     "Creates an atmosphere of pure tranquility in your surroundings",
//     "Charcoal Free formula — cleaner and healthier burning experience",
//     "Useful for every occasion — Religious Functions, Celebrations & Daily Worship",
//     "Ideal for Pooja, Meditation, Yoga & Stress Relief",
//     "Brings Peace, Positivity & Serene Floral Energy to your surroundings",
//   ],

//   highlights: [
//     "Flowery Accords & Oriental Touch",
//     "Unmatched Strong Aroma",
//     "Takes You to Serenity of Nature",
//     "Charcoal Free",
//     "Long Lasting Aroma",
//     "Premium Scented",
//   ],

//   packing: [
//     "100g",
//   ],

//   usage:
//     "Suitable for Daily Worship, Pooja, Meditation, Yoga, Religious Functions, Celebrations, Stress Relief & Home Fragrance.",

//   howToUse: [
//     "Place the agarbatti in a suitable incense holder or stand.",
//     "Light the tip and allow it to flame for 5–10 seconds.",
//     "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
//     "Place the holder in a safe, well-ventilated area away from flammables.",
//     "Let the clean and mesmerizing Heena Flowery Accords with Oriental touch transport you to the serenity of nature.",
//     "Never leave burning incense unattended.",
//   ],

//   safety:
//     "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

//   flipkartUrl: "#",

//   img: sweden2,
//   imgs: [sweden2, sweden2],
// },

{
  id: "wild-kasturi-musk-agarbatti",
  name: "Prakhyat Wild Kasturi Premium Scented Agarbatti",
  type: "Agarbatti",
  tier: "Scented",
  fragrance: "Wild Kasturi — Strong Powdery Musk Type",
  scent: "Strong Powdery Musk Notes — Fast Spreading & Deep Lingering Aroma",
  material: "Wood Powder",
  charcoalFree: true,
  duration: "20 to 30 Min",
  itemLength: "23 centimeters",

  weight: [
    { size: "100g", mrp: "₹__" },
  ],

  shortDesc:
    "Premium Scented Wild Kasturi Agarbatti with a strong powdery note of Musk — spreads fast across larger spaces, making its presence felt everywhere like going with the flow of scent.",

  longDesc:
    "PRAKHYAT – PREMIUM SCENTED WILD KASTURI AGARBATTI — A strong powdery note of Musk that spreads fast across larger spaces quickly, making its presence felt everywhere — like going with the flow of scent. A bold and commanding fragrance of Wild Kasturi that fills every corner with a rich, deep musky warmth that stays and lingers long after the stick has burned. Charcoal Free Scented Agarbatti made from Wood Powders, giving a lasting aroma that creates a pleasant atmosphere in your living space. Ideal for Daily Worship, Pooja, Meditation, Yoga, Stress Relief, and bringing Peace and Positive Energy to your life.",

  benefits: [
    "Strong powdery Musk note — spreads fast across larger spaces instantly",
    "Makes its presence felt everywhere — like going with the flow of scent",
    "Bold and commanding Wild Kasturi fragrance with rich deep musky warmth",
    "Fills every corner with a deep lingering aroma that stays long",
    "Charcoal Free formula — cleaner and healthier burning experience",
    "Useful for every occasion — Religious Functions, Celebrations & Daily Worship",
    "Ideal for Pooja, Meditation, Yoga & Stress Relief",
    "Brings Peace, Positivity & Bold Musky Energy to your surroundings",
  ],

  highlights: [
    "Wild Kasturi Musk Fragrance",
    "Strong Powdery Musk Notes",
    "Fast Spreading Large Space Coverage",
    "Charcoal Free",
    "Long Lasting Aroma",
    "Premium Scented",
  ],

  packing: [
    "100g",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Religious Functions, Celebrations, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the agarbatti in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the strong powdery Wild Kasturi Musk aroma spread fast and fill every corner of your space with bold warmth and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: kasturisented1,
  imgs: [kasturisented2, kasturisented3],
},
];




export const DHOOP_CONE = [

{
  id: "gold-chandan-masala-cone-dhoop",
  name: "Prakhyat Gold Chandan Premium Dhoop Cones",
  type: "Dhoop Cone",
  tier: "Premium",
  fragrance: "Forest Sandal — Pure Mysore Chandan",
  scent: "Warm, Woody, Sweet & Sacred Sandalwood",
  material: "Flower Powders, Wood Powders, Natural Oils, Resin, Ailanthus Malabarica",
  duration: "15 to 20 Min",
  itemLength: "1.25 inches",

  weight: [
    { size: "80g", mrp: "₹__", packing: "Pet Jar Bottle" },
  ],

  shortDesc:
    "Premium Gold Chandan Dhoop Cones with Forest Sandal fragrance — Pure Mysore Chandan aroma that is warm, woody & sweet, spreading quickly across large spaces and converting your home into a divine Spiritual Atmosphere.",

  longDesc:
    "PRAKHYAT – PREMIUM GOLD CHANDAN DHOOP CONES — GOLD CHANDAN carries the essence of Forest Sandal fragrance — the Pure Mysore Chandan. As Sandal is considered one of the most sacred forms of worshipping Gods, making it a first choice — its warm, woody & sweet smell lingers for hours after burning, converting your place into a Spiritual Atmosphere and bringing calmness and peace to your life. Made from selected, pure, high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — it delivers a long-lasting sandalwood aroma that spreads quickly even in large spaces, creating a pleasant and divine atmosphere in your living space.",

  benefits: [
    "Spreads pure Forest Sandal Aroma — Warm, Woody & Sweet Mysore Chandan",
    "Sandalwood — one of the most sacred fragrances for worshipping Gods",
    "Aroma lingers for hours after burning with beautiful lingering effect",
    "Spreads quickly across large spaces for wide aromatic coverage",
    "Ideal for Pooja, Meditation, Yoga & Spiritual Rituals",
    "Specially suited for Aromatherapy, Garden Fragrance & Stress Relief",
    "Brings Calmness, Peace & Positive Energy to your surroundings",
  ],

  highlights: [
    "Pure Mysore Chandan Fragrance",
    "100% Natural Ingredients",
    "Long Lasting Aroma",
    "Smooth & Even Burning",
  ],

  packing: [
    "80g — Pet Jar Bottle",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the dhoop cone in a suitable cone incense holder or heat-resistant plate.",
    "Light the tip of the cone and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and begin emitting fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammable materials.",
    "Let the sacred Forest Sandal aroma of Pure Mysore Chandan fill your space with calmness and spiritual energy.",
    "Never leave burning dhoop unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: goldChandan,
  imgs: [goldChandan],
},
{
  id: "samruddhi-masala-cone-dhoop",
  name: "Prakhyat Samruddhi Premium Dhoop Cones",
  type: "Dhoop Cone",
  tier: "Premium",
  fragrance: "Fancy Floral Accord — Jasmine, Lily, Rose & Vanilla",
  scent: "Sweet, Powdery, Fresh Garden & Floral Bouquet",
  material: "Flower Powders, Wood Powders, Natural Oils, Resin, Ailanthus Malabarica",
  duration: "15 to 20 Min",
  itemLength: "1.25 inches",

  weight: [
    { size: "80g", mrp: "₹__", packing: "Pet Jar Bottle" },
  ],

  shortDesc:
    "Premium Samruddhi Dhoop Cones with a Fancy Floral Accord — a timeless bouquet of Jasmine, Lily, Rose & Vanilla that is sweet, powdery & fresh, lingering in your senses forever and staying longer in every room.",

  longDesc:
    "PRAKHYAT – PREMIUM SAMRUDDHI DHOOP CONES — SAMRUDDHI carries the essence of a Fancy Floral Accord — a timeless fragrance that lingers in your senses forever. The fancy floral note outstands all other varieties with its sweet, powdery & fresh garden character that stays longer in every room. A total bouquet of fresh flowers — Jasmine, Lily, Rose & Vanilla — all put together in perfect harmony. Made from selected, pure, high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — it delivers a long-lasting floral aroma with a beautiful lingering effect that spreads quickly, creating a pleasant and refreshing atmosphere in your living space.",

  benefits: [
    "Spreads a Fancy Floral Accord — Jasmine, Lily, Rose & Vanilla Bouquet",
    "Timeless fragrance that lingers in your senses forever",
    "Sweet, Powdery & Fresh Garden note that stays longer in every room",
    "Outstands all other varieties with its total floral bouquet character",
    "Ideal for Pooja, Meditation, Yoga & Daily Spiritual Rituals",
    "Specially suited for Aromatherapy, Garden Fragrance & Stress Relief",
    "Brings Peace, Freshness & Positive Energy to your surroundings",
  ],

  highlights: [
    "Fancy Floral Accord",
    "100% Natural Ingredients",
    "Long Lasting Aroma",
    "Smooth & Even Burning",
  ],

  packing: [
    "80g — Pet Jar Bottle",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the dhoop cone in a suitable cone incense holder or heat-resistant plate.",
    "Light the tip of the cone and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and begin emitting fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammable materials.",
    "Let the timeless Fancy Floral Accord of Jasmine, Lily, Rose & Vanilla fill your space with freshness and positive energy.",
    "Never leave burning dhoop unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: samruddhi,
  imgs: [samruddhi],
},
{
  id: "dharmik-masala-cone-dhoop",
  name: "Prakhyat Dharmik Premium Dhoop Cones",
  type: "Dhoop Cone",
  tier: "Premium",
  fragrance: "Oriental Flowery Perfume",
  scent: "Floral, Spicy, Resinous, Oriental & Exotic",
  material: "Flower Powders, Wood Powders, Natural Oils, Resin, Ailanthus Malabarica",
  duration: "15 to 20 Min",
  itemLength: "1.25 inches",

  weight: [
    { size: "80g", mrp: "₹__", packing: "Pet Jar Bottle" },
  ],

  shortDesc:
    "Premium Dharmik Dhoop Cones with an Oriental Flowery Perfume — a rich, warm & exotic blend of floral, spicy & resinous notes, crafted in the tradition of southern Indian temples for a true spiritual aromatic journey.",

  longDesc:
    "PRAKHYAT – PREMIUM DHARMIK DHOOP CONES — DHARMIK carries the essence of an Oriental Flowery Perfume, beautifully combining the Oriental and Modern forms of aroma with rich, warm & exotic notes. Like the sacred incense used in traditional southern Indian temples and shrines, it is a true mixture of flowery floral, spicy & resinous notes — often used in religious gatherings to connect devotees to a different spiritual world, leaving a long-lasting memory. Specially crafted for a smooth and pleasant aromatic journey. Made from selected, pure, high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — it delivers a long-lasting aroma with a beautiful lingering effect that spreads quickly, creating a pleasant and spiritually rich atmosphere in your living space.",

  benefits: [
    "Spreads rich Oriental Flowery Perfume — Floral, Spicy & Resinous",
    "Inspired by sacred incense of traditional southern Indian temples & shrines",
    "Rich, warm & exotic notes that connect you to a different spiritual world",
    "Leaves a long-lasting memory with beautiful lingering aroma",
    "Ideal for Pooja, Meditation, Yoga & Religious Gatherings",
    "Specially suited for Aromatherapy, Garden Fragrance & Stress Relief",
    "Brings Peace, Positivity & Spiritual Energy to your surroundings",
  ],

  highlights: [
    "Oriental Flowery Perfume",
    "100% Natural Ingredients",
    "Long Lasting Aroma",
    "Smooth & Even Burning",
  ],

  packing: [
    "80g — Pet Jar Bottle",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Religious Gatherings, Aromatherapy, Garden Fragrance, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the dhoop cone in a suitable cone incense holder or heat-resistant plate.",
    "Light the tip of the cone and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and begin emitting fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammable materials.",
    "Let the rich Oriental Flowery aroma fill your space with spiritual warmth and positivity.",
    "Never leave burning dhoop unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: dharmik,
  imgs: [dharmik],
},
{
  id: "amogh-masala-cone-dhoop",
  name: "Prakhyat Amogh Premium Dhoop Cones",
  type: "Dhoop Cone",
  tier: "Premium",
  fragrance: "White Flowers Combination — Arabian Jasmine, Lily & Champa",
  scent: "Floral, Aromatic, Traditional Indian",
  material: "Flower Powders, Wood Powders, Natural Oils, Resin, Ailanthus Malabarica",
  duration: "15 to 20 Min",
  itemLength: "1.25 inches",

  weight: [
    { size: "80g", mrp: "₹__", packing: "Pet Jar Bottle" },
  ],

  shortDesc:
    "Premium Amogh Dhoop Cones crafted with White Flowers combination — Arabian Jasmine, Lily & Champa — spreading a vibrant, sacred floral fragrance loved by Indians for centuries.",

  longDesc:
    "PRAKHYAT – PREMIUM AMOGH DHOOP CONES — Crafted with a beautiful White Flowers combination of Arabian Jasmine, Lily & Champa along with aromatic powders, this dhoop cone throws a vibrant fragrance that has been loved by native Indians for centuries. These flowers are offered to Gods in every sacred occasion, making this dhoop ideal for all spiritual rituals. Made from selected, pure, high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — it gives a long-lasting floral aroma with a beautiful lingering effect in your surroundings, creating a pleasant atmosphere in your living space.",

  benefits: [
    "Spreads vibrant White Floral Aroma — Arabian Jasmine, Lily & Champa",
    "Sacred fragrance loved by native Indians for centuries",
    "Long-lasting aroma with a beautiful lingering effect",
    "Ideal for Pooja, Meditation, Yoga & Spiritual Rituals",
    "Creates a Pleasant & Positive Atmosphere in your living space",
    "Specially suited for Aromatherapy, Garden Fragrance & Stress Relief",
    "Brings Peace, Purity & Positive Energy to your surroundings",
  ],

  highlights: [
    "White Floral Fragrance",
    "100% Natural Ingredients",
    "Long Lasting Aroma",
    "Smooth & Even Burning",
  ],

  packing: [
    "80g — Pet Jar Bottle",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the dhoop cone in a suitable cone incense holder or heat-resistant plate.",
    "Light the tip of the cone and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and begin emitting fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammable materials.",
    "Let the sacred White Floral aroma of Jasmine, Lily & Champa fill your space with peace and positivity.",
    "Never leave burning dhoop unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: amogh,
  imgs: [amogh],
},

{
  id: "guru-mantra-masala-cone-dhoop",
  name: "Prakhyat Guru Mantra Premium Dhoop Cones",
  type: "Dhoop Cone",
  tier: "Premium",
  fragrance: "Powdery Flowers — Lily, Jasmine & Rose",
  scent: "Floral, Powdery, Spiritual & Divine",
  material: "Flower Powders, Wood Powders, Natural Oils, Resin, Ailanthus Malabarica",
  duration: "15 to 20 Min",
  itemLength: "1.25 inches",

  weight: [
    { size: "80g", mrp: "₹__", packing: "Pet Jar Bottle" },
  ],

  shortDesc:
    "Divinely crafted Premium Guru Mantra Dhoop Cones with well-balanced Powdery Floral notes of Lily, Jasmine & Rose — a powerful sacred fragrance that shows the path to devotees and fills your space with divine energy.",

  longDesc:
    "PRAKHYAT – PREMIUM GURU MANTRA DHOOP CONES — A divinely crafted Premium Dhoop Cone that carries all the fragrance a devotee needs to feel spiritually connected. With powerful, well-balanced Powdery Floral notes of Lily, Jasmine & Rose, it distinguishes itself in its league — always giving more than just fragrance. Made from selected, pure, high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — it delivers a long-lasting aroma with a beautiful lingering effect that spreads quickly throughout your surroundings, creating a pleasant and divine atmosphere in your living space.",

  benefits: [
    "Spreads divine Powdery Floral Aroma — Lily, Jasmine & Rose",
    "Powerful sacred fragrance that spiritually uplifts devotees",
    "Well-balanced notes that distinguish it in its league",
    "Long-lasting aroma with beautiful lingering effect",
    "Ideal for Pooja, Meditation, Yoga & Spiritual Rituals",
    "Specially suited for Aromatherapy, Garden Fragrance & Stress Relief",
    "Brings Peace, Positivity & Divine Energy to your surroundings",
  ],

  highlights: [
    "Divine Floral Fragrance",
    "100% Natural Ingredients",
    "Long Lasting Aroma",
    "Smooth & Even Burning",
  ],

  packing: [
    "80g — Pet Jar Bottle",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the dhoop cone in a suitable cone incense holder or heat-resistant plate.",
    "Light the tip of the cone and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and begin emitting fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammable materials.",
    "Let the divine Powdery Floral aroma of Lily, Jasmine & Rose fill your space with peace and spiritual energy.",
    "Never leave burning dhoop unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: guru,
  imgs: [guru],
},

{
  id: "golden-guggal-premium-cone-dhoop",
  name: "Prakhyat Golden Guggal Extra Premium Dhoop Cones",
  type: "Dhoop Cone",
  tier: "Extra Premium",
  fragrance: "Guggal & Frankincense — Natural Resinous Oriental",
  scent: "Smooth Guggal, Frankincense, Resinoid & Deep Oriental",
  material: "Natural Guggal Resin, Frankincense, Flower Powders, Wood Powders, Natural Oils, Resin, Ailanthus Malabarica",
  duration: "15 to 20 Min",
  itemLength: "1.25 inches",

  weight: [
    { size: "80g", mrp: "₹__", packing: "Pet Jar Bottle" },
  ],

  shortDesc:
    "Extra Premium Golden Guggal Dhoop Cones with Guggal & Frankincense fragrance — a natural source of aroma since ancient times, derived from Natural Guggal, Frankincense & Resinoids, giving an unmatched Oriental fragrance that lets you feel the essence of the spiritual world.",

  longDesc:
    "PRAKHYAT – GOLDEN GUGGAL EXTRA PREMIUM DHOOP CONES — A natural source of aroma since ancient times — people used to travel from one place to another carrying Guggal & Frankincense for religious and spiritual rituals. Derived from resins of Natural Guggal, Frankincense, Flowers & Resinoids, all giving an Oriental type of fragrance unmatched for its uniqueness and deep holding power — feel the essence of the spiritual world. Made from pure, high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — it delivers a smooth, long-lasting Guggal Frankincense aroma that spreads quickly even across large spaces, creating a sacred and spiritually rich atmosphere in your living space.",

  benefits: [
    "Spreads Smooth Guggal & Frankincense Aroma — Deep Oriental & Resinous",
    "A natural source of sacred aroma used since ancient times for spiritual rituals",
    "Derived from Natural Guggal, Frankincense, Flowers & Resinoids",
    "Unmatched Oriental fragrance with deep holding power — feel the spiritual world",
    "Ideal for Pooja, Meditation, Yoga & Temple Rituals",
    "Specially suited for Aromatherapy, Garden Fragrance & Stress Relief",
    "Purifies surroundings and brings Peace, Positivity & Spiritual Energy to your life",
  ],

  highlights: [
    "Guggal & Frankincense Fragrance",
    "100% Natural Ingredients",
    "Long Lasting Aroma",
    "Smooth & Even Burning",
  ],

  packing: [
    "80g — Pet Jar Bottle",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Temple Rituals, Aromatherapy, Garden Fragrance, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the dhoop cone in a suitable cone incense holder or heat-resistant plate.",
    "Light the tip of the cone and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and begin emitting fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammable materials.",
    "Let the ancient sacred Guggal & Frankincense aroma fill your space with spiritual energy and deep positivity.",
    "Never leave burning dhoop unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: guggal,
  imgs: [guggal],
},

{
  id: "utsav-premium-cone-dhoop",
  name: "Prakhyat Utsav Extra Premium Dhoop Cones",
  type: "Dhoop Cone",
  tier: "Extra Premium",
  fragrance: "Strong Woody & Musky Perfume",
  scent: "Woody, Musky, Soft Floral Undertones & Natural Resinous",
  material: "Flower Powders, Wood Powders, Natural Oils, Resin, Ailanthus Malabarica",
  duration: "15 to 20 Min",
  itemLength: "1.25 inches",

  weight: [
    { size: "80g", mrp: "₹__", packing: "Pet Jar Bottle" },
  ],

  shortDesc:
    "Extra Premium Utsav Dhoop Cones with a Strong Woody & Musky Perfume — soft floral undertones blended with natural resins, whispering from the woods and spreading to far distances, always making your surroundings soothing and aromatic.",

  longDesc:
    "PRAKHYAT – UTSAV EXTRA PREMIUM DHOOP CONES — A very strong Woody & Musky note with underlined soft flowery notes blended with natural resins, giving a high-grade fragrance. A true reminiscence of woody musky fragrance whispering from the woods and spreading to far distances — always making your surroundings soothing and deeply aromatic. Made from pure, high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — it delivers a long-lasting rich woody musky aroma that spreads quickly even across large spaces, creating a pleasant and luxurious atmosphere in your living space.",

  benefits: [
    "Spreads a Strong Woody & Musky Perfume with soft floral undertones",
    "High-grade fragrance blended with natural resins for a rich aroma",
    "True reminiscence of woody musky fragrance whispering from the woods",
    "Spreads to far distances — always making surroundings soothing and aromatic",
    "Ideal for Pooja, Meditation, Yoga & Daily Spiritual Rituals",
    "Specially suited for Aromatherapy, Garden Fragrance & Stress Relief",
    "Brings Peace, Warmth & Positive Energy to your surroundings",
  ],

  highlights: [
    "Strong Woody & Musky Perfume",
    "100% Natural Ingredients",
    "Long Lasting Aroma",
    "Smooth & Even Burning",
  ],

  packing: [
    "80g — Pet Jar Bottle",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the dhoop cone in a suitable cone incense holder or heat-resistant plate.",
    "Light the tip of the cone and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and begin emitting fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammable materials.",
    "Let the Strong Woody & Musky aroma whisper from the woods and fill your space with warmth and positive energy.",
    "Never leave burning dhoop unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: utsav,
  imgs: [utsav],
},
{
  id: "woods-premium-cone-dhoop",
  name: "Prakhyat Woods Extra Premium Dhoop Cones",
  type: "Dhoop Cone",
  tier: "Extra Premium",
  fragrance: "Rich Classic Woody Fragrance",
  scent: "Woody, Creamy Amber, Earthy & Deep Forest",
  material: "Flower Powders, Wood Powders, Natural Oils, Resin, Ailanthus Malabarica",
  duration: "15 to 20 Min",
  itemLength: "1.25 inches",

  weight: [
    { size: "80g", mrp: "₹__", packing: "Pet Jar Bottle" },
  ],

  shortDesc:
    "Extra Premium Woods Dhoop Cones with a Rich Classic Woody Fragrance — smooth, creamy amber & earthy notes just like a deep forest, with a classy warm aroma that lingers for hours and always leaves you wanting more.",

  longDesc:
    "PRAKHYAT – WOODS EXTRA PREMIUM DHOOP CONES — A smooth and rich Classic Woody Fragrance designed to make its space in every home. Presenting a woody, creamy amber & earthy fragrance just like in a deep forest — its classy and warm aroma lingers for hours, always leaving you wanting one more. Made from pure, high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — it delivers a long-lasting rich woody aroma that spreads quickly even across large spaces, creating a pleasant and luxurious atmosphere in your living space.",

  benefits: [
    "Spreads Rich Classic Woody Fragrance — Creamy Amber & Deep Forest Earthy Notes",
    "Smooth & classy warm aroma that lingers for hours",
    "Designed to make its space in every home — a truly universal woody fragrance",
    "Spreads quickly across large spaces for wide aromatic coverage",
    "Ideal for Pooja, Meditation, Yoga & Daily Spiritual Rituals",
    "Specially suited for Aromatherapy, Garden Fragrance & Stress Relief",
    "Brings Peace, Warmth & Positive Energy to your surroundings",
  ],

  highlights: [
    "Rich Classic Woody Fragrance",
    "100% Natural Ingredients",
    "Long Lasting Aroma",
    "Smooth & Even Burning",
  ],

  packing: [
    "80g — Pet Jar Bottle",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the dhoop cone in a suitable cone incense holder or heat-resistant plate.",
    "Light the tip of the cone and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and begin emitting fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammable materials.",
    "Let the Rich Classic Woody aroma of deep forest fill your space with warmth and positive energy.",
    "Never leave burning dhoop unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: wood,
  imgs: [wood],
},

{
  id: "lotus-premium-cone-dhoop",
  name: "Prakhyat Lotus Extra Premium Dhoop Cones",
  type: "Dhoop Cone",
  tier: "Extra Premium",
  fragrance: "Best Quality Amber Rose Wood",
  scent: "High Classic Rose, Amber, Woody & Natural Resinous",
  material: "Flower Powders, Wood Powders, Natural Oils, Resin, Ailanthus Malabarica",
  duration: "15 to 20 Min",
  itemLength: "1.25 inches",

  weight: [
    { size: "80g", mrp: "₹__", packing: "Pet Jar Bottle" },
  ],

  shortDesc:
    "Extra Premium Lotus Dhoop Cones with Best Quality Amber Rose Wood fragrance — a unique combination of High Classic Rose, Amber & Wood with Natural Resins, throwing a strong rosy powdery aroma felt from long distances that makes you fall for it again and again.",

  longDesc:
    "PRAKHYAT – LOTUS EXTRA PREMIUM DHOOP CONES — One of the most favorite fragrances — an incense that makes you fall for it again and again. A combination of High Classic Rose, Amber & Wood mixed with Natural Resins, throwing a unique aroma that can be felt from long distances. It lingers a strong rosy powdery fragrance that is truly irresistible to its users. Made from pure, high-quality ingredients — Flower Powders, Wood Powders, Natural Oils, Resin & Ailanthus Malabarica — it delivers a long-lasting rich aroma that spreads quickly even across large spaces, creating a pleasant and luxurious atmosphere in your living space.",

  benefits: [
    "Spreads Best Quality Amber Rose Wood Fragrance — High Classic Rose, Amber & Woody",
    "Unique aroma combination with Natural Resins felt from long distances",
    "Lingers a strong rosy powdery fragrance that is truly irresistible",
    "One of the most favorite fragrances — makes you fall for it again and again",
    "Ideal for Pooja, Meditation, Yoga & Daily Spiritual Rituals",
    "Specially suited for Aromatherapy, Garden Fragrance & Stress Relief",
    "Brings Peace, Warmth & Positive Energy to your surroundings",
  ],

  highlights: [
    "Amber Rose Wood Fragrance",
    "100% Natural Ingredients",
    "Long Lasting Aroma",
    "Smooth & Even Burning",
  ],

  packing: [
    "80g — Pet Jar Bottle",
  ],

  usage:
    "Suitable for Daily Worship, Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Stress Relief & Home Fragrance.",

  howToUse: [
    "Place the dhoop cone in a suitable cone incense holder or heat-resistant plate.",
    "Light the tip of the cone and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and begin emitting fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammable materials.",
    "Let the irresistible Amber Rose Wood aroma fill your space with warmth and positive energy.",
    "Never leave burning dhoop unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: lotus,
  imgs: [lotus],
},

];

export const DHOOP_STICK = [


{
  id: "shri-ram-chandan-dhoop-stick",
  name: "Prakhyat Premium Ram Chandan Dhoop Sticks",
  type: "Dhoop Stick",
  tier: "Premium",
  fragrance: "Pure Mysore Sandal",
  scent: "Pure Mysore Sandal — Warm, Woody, Sweet, Natural Masala Type",
  material: "Wood Powder",
  duration: "30-40 Mins",

  weight: [
    { size: "100g", mrp: "₹--" }, // price client se confirm karna
  ],

  shortDesc:
    "Premium Ram Chandan Dhoop Sticks with Pure Mysore Sandal fragrance — one of the most sacred forms of worshipping Gods. Warm, woody & sweet aroma that lingers for hours, converting your space into a divine spiritual atmosphere.",

  longDesc:
    "PRAKHYAT – PREMIUM RAM CHANDAN – DHOOP STICKS. Pure Mysore Sandal Fragrance — as Sandal is considered one of the most sacred forms of worshipping Gods, making it a first choice. Its warm, woody, sweet smell lingers for hours after burning of the stick, converting your place into a Spiritual Atmosphere and bringing calmness and peace to your life. Made from selected, pure high-quality ingredients including Flower Powders, Wood Powders, Natural Oils, Resin, and Ailanthus Malabarica — giving a very good long-lasting aroma with pure Mysore Sandal fragrance that lingers in the surrounding area, creating a pleasant atmosphere in your living space and spreading quickly across large spaces.",

  benefits: [
    "Pure Mysore Sandal fragrance — one of the most sacred forms of worshipping Gods",
    "Warm, Woody & Sweet aroma that lingers for hours after burning",
    "Converts your space into a Divine Spiritual Atmosphere",
    "Creates a Pleasant & Refreshing Atmosphere in your surroundings",
    "Very special for Pooja, Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress and brings Calmness, Peace & Positive Energy to your life",
  ],

  highlights: [
    "Pure Mysore Sandal",
    "Sacred Temple Fragrance",
    "Warm Woody Sweet",
    "Long Burning",
  ],

  packing: [
    "100g - MRP ₹--/-", // price update karna
  ],

  usage:
    "Suitable for Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the dhoop stick in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the sacred Mysore Sandal aroma convert your space into a spiritual atmosphere.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: ramchandan1,
  imgs: [ramchandan1, ramchandan2, ramchandan3],
},

{
  id: "gurukrupa-dhoop-stick",
  name: "Prakhyat Premium Gurukrupa Dhoop Sticks",
  type: "Dhoop Stick",
  tier: "Premium",
  fragrance: "Powdery Floral",
  scent: "Lily, Jasmine, Rose — Powdery Floral Perfume, Natural Masala Type",
  material: "Wood Powder",
  duration: "30-40 Mins",

  weight: [
    { size: "100g", mrp: "₹--" }, // price client se confirm karna
  ],

  shortDesc:
    "Premium Gurukrupa Dhoop Sticks — divinely crafted with well-balanced powdery floral notes of Lily, Jasmine & Rose. A powerful fragrance that shows the path to devotees, always giving more than just aroma.",

  longDesc:
    "PRAKHYAT – PREMIUM GURUKRUPA – DHOOP STICKS. A divinely crafted Premium Dhoop Stick which has all the fragrance it needs to show the path to devotees — a powerful note that leaves an impact on its users, always giving more than fragrance. Well-balanced notes of powdery flowers like Lily, Jasmine, and Rose make it distinguished in its league, giving it a special place for Puja, Meditation, Yoga, relieving Stress, and bringing Peace and Positive Energy to your living. Made from selected, pure high-quality ingredients including Flower Powders, Wood Powders, Natural Oils, Resin, and Ailanthus Malabarica — giving a very good long-lasting aroma that lingers in the surrounding area, creating a pleasant atmosphere in your living space and spreading quickly across large spaces.",

  benefits: [
    "Divinely crafted with well-balanced Lily, Jasmine & Rose powdery floral notes",
    "Powerful fragrance that leaves a deep impact — always gives more than just aroma",
    "Lingering aroma effect that spreads quickly across large spaces",
    "Creates a Pleasant & Refreshing Atmosphere in your surroundings",
    "Very special for Pooja, Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress and brings Peace & Positive Energy to your living",
  ],

  highlights: [
    "Lily Jasmine Rose Blend",
    "Powdery Floral Aroma",
    "Divine Spiritual Scent",
    "Long Burning",
  ],

  packing: [
    "100g - MRP ₹--/-", // price update karna
  ],

  usage:
    "Suitable for Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the dhoop stick in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the divine Gurukrupa aroma fill your space with devotion and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: gurukrupa1,
  imgs: [gurukrupa1, gurukrupa2, gurukrupa3],
},

{
  id: "elegant-rose-dhoop-stick",
  name: "Prakhyat Premium Elegant Rose Dhoop Sticks",
  type: "Dhoop Stick",
  tier: "Premium",
  fragrance: "Elegant Rose",
  scent: "Rosy, Woody, Sweet Floral Accords — Royal Rose, Natural Masala Type",
  material: "Wood Powder",
  duration: "30-40 Mins",

  weight: [
    { size: "100g", mrp: "₹--" }, // price client se confirm karna
  ],

  shortDesc:
    "Premium Elegant Rose Dhoop Sticks — crafted from rose, a fragrance used for over 5000 years. Royal sweet floral accords with a rosy woody warmth that lifts your mood and fills your space with peace and positivity.",

  longDesc:
    "PRAKHYAT – PREMIUM ELEGANT ROSE – DHOOP STICKS. The flower Rose has been used for more than 5000 years as a source of fragrance — its petals giving royal sweet floral accords, always ahead of times and a must-have perfumery note. A rosy woody fragrance that lifts up mood and brings a peaceful atmosphere in your surroundings, giving it a special place for Puja, Meditation, Yoga, relieving Stress, and bringing Peace and Positive Energy to your living. Made from selected, pure high-quality ingredients including Flower Powders, Wood Powders, Natural Oils, Resin, and Ailanthus Malabarica — giving a very good long-lasting aroma that lingers in the surrounding area, creating a pleasant atmosphere in your living space and spreading quickly across large spaces.",

  benefits: [
    "Royal Sweet Floral Rose fragrance used since 5000 years — timeless & elegant",
    "Rosy Woody aroma that lifts your mood and brings peaceful surroundings",
    "Lingering aroma effect that spreads quickly across large spaces",
    "Creates a Pleasant & Refreshing Atmosphere in your surroundings",
    "Very special for Pooja, Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress and brings Peace & Positive Energy to your living",
  ],

  highlights: [
    "Premium Rose Aroma",
    "Royal Sweet Floral",
    "Mood Lifting Fragrance",
    "Long Burning",
  ],

  packing: [
    "100g - MRP ₹--/-", // price update karna
  ],

  usage:
    "Suitable for Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the dhoop stick in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the elegant Rose aroma lift your mood and fill your space with positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: elegant1,
  imgs: [elegant1, elegant2, elegant3],
},

{
  id: "woods-dhoop-stick",
  name: "Prakhyat Woods Luxury Dhoop Sticks",
  type: "Dhoop Stick",
  tier: "Luxury",
  fragrance: "Woody Creamy Amber",
  scent: "Woody, Creamy, Amber, Earthy — Deep Forest, Natural Masala Type",
  material: "Wood Powder",
  duration: "30-40 Mins",

  weight: [
    { size: "50g", mrp: "₹--" }, // price client se confirm karna
  ],

  shortDesc:
    "Woods Luxury Dhoop Sticks — a woody, creamy amber & earthy fragrance just like a deep forest. Classy and rich aroma that lingers for hours, leaving you wanting more every single time.",

  longDesc:
    "PRAKHYAT – WOODS – LUXURY DHOOP STICKS. Presenting a woody, creamy, amber and earthy fragrance just like in a deep forest — its classy and rich aroma lingers and lasts for hours, asking for one more time. Made from pure high-quality ingredients including Flower Powders, Wood Powders, Natural Oils, Resin, and Ailanthus Malabarica — giving a very good long-lasting aroma that lingers in the surrounding area, creating a pleasant atmosphere in your living space and spreading quickly across large spaces.",

  benefits: [
    "Deep forest-inspired Woody, Creamy Amber & Earthy fragrance",
    "Classy and rich aroma that lingers for hours — leaves you wanting more",
    "Lingering aroma effect that spreads quickly across large spaces",
    "Creates a Pleasant & Refreshing Atmosphere in your surroundings",
    "Very special for Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress and brings Peace & Positive Energy to your living",
  ],

  highlights: [
    "Woody Creamy Amber",
    "Deep Forest Aroma",
    "Luxury Fragrance",
    "Long Burning",
  ],

  packing: [
    "50g - MRP ₹--/-", // price update karna
  ],

  usage:
    "Suitable for Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the dhoop stick in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the deep forest Woods aroma fill your space with calm and richness.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: woods1,
  imgs: [woods1, woods2, woods3],
},
{
  id: "oudh-dhoop-stick",
  name: "Prakhyat Elegant Oudh Luxury Dhoop Sticks",
  type: "Dhoop Stick",
  tier: "Luxury",
  fragrance: "Royal Oudh",
  scent: "Strong Oudh, Vetiver, Smoky, Woody, Pungent, Sandal — Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "30-40 Mins",

  weight: [
    { size: "50g", mrp: "₹--" }, // client ne price nahi diya, update karna
  ],

  shortDesc:
    "Luxury Oudh Dhoop Sticks crafted with aged & matured Oudh perfume — layered with smoky, woody, vetiver & sandal notes that mesmerize your senses and transport you to a royal world of fragrance.",

  longDesc:
    "PRAKHYAT – ELEGANT OUDH – LUXURY DHOOP STICKS. Fragrance made from selected Oudh perfume, aged and matured enough to give a signature note layered with different smoky, woody, pungent, Sandal, and Vetiver notes — making it mesmerizing and relaxing, transporting you to a Royal World of Fragrance. Made from pure high-quality ingredients including Flower Powders, Wood Powders, Natural Oils, Resin, and Ailanthus Malabarica — giving a very good long-lasting aroma with strong Oudh, Vetiver, and Smoky fragrance that lingers in the surrounding area, creating a pleasant atmosphere in your living space.",

  benefits: [
    "Strong Royal Oudh fragrance layered with Smoky, Vetiver & Sandal notes",
    "Lingering aroma effect that spreads quickly across large spaces",
    "Creates a Pleasant & Refreshing Atmosphere in your surroundings",
    "Very special for Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress and brings Peace & Positive Energy to your living",
    "Long Lasting 30–40 Min burn time with 100% Natural Ingredients",
  ],

  highlights: [
    "Royal Oudh Aroma",
    "Luxury Fragrance",
    "Oriental Blend",
    "Long Burning",
  ],

  packing: [
    "50g - MRP ₹--/-", // price update karna client se
  ],

  usage:
    "Suitable for Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the dhoop stick in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the Royal Oudh aroma fill your space with calmness and luxury.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: oudh1,
  imgs: [oudh1, oudh2, oudh3],
},
{
  id: "sudarshan-dhoop-stick",
  name: "Prakhyat Premium Sudarshan Dhoop Sticks",
  type: "Dhoop Stick",
  tier: "Premium",
  fragrance: "Ancient Oriental",
  scent: "Oriental Flowery — Woody, Floral, Spicy, Heavy Attars, Natural Masala Type",
  material: "Wood Powder",
  duration: "30-40 Mins",

  weight: [
    { size: "50g", mrp: "₹--" }, // price client se confirm karna
  ],

  shortDesc:
    "Premium Sudarshan Dhoop Sticks — a classic blend of ancient and modern oriental aroma. Rich, warm exotic notes of woody, floral, spicy & heavy attars used across India, Middle East & Asian temples since traditional times.",

  longDesc:
    "PRAKHYAT – PREMIUM SUDARSHAN – DHOOP STICKS. Made from Oriental Fragrance — a classic combination of ancient and modern forms of aroma with rich, warm, exotic notes like those used in traditional times in India, the Middle East, and the Asian world. A mixture of woody, floral, spicy, and heavy attars often used in Temples, Monasteries, and Religious gatherings — connecting to a different spiritual world and leaving a long-lasting memory. Giving it a special place for Puja, Meditation, Yoga, relieving Stress, and bringing Peace and Positive Energy to your living. Made from selected, pure high-quality ingredients including Flower Powders, Wood Powders, Natural Oils, Resin, and Ailanthus Malabarica — giving a very good long-lasting ancient oriental fragrance that lingers in the surrounding area, creating a pleasant atmosphere in your living space and spreading quickly across large spaces.",

  benefits: [
    "Ancient Oriental fragrance — classic blend of Woody, Floral, Spicy & Heavy Attars",
    "Rich warm exotic aroma used in Temples, Monasteries & Religious gatherings",
    "Connects to a different spiritual world leaving a long-lasting memory",
    "Creates a Pleasant & Refreshing Atmosphere in your surroundings",
    "Very special for Pooja, Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress and brings Peace & Positive Energy to your living",
  ],

  highlights: [
    "Ancient Oriental Aroma",
    "Woody Floral Spicy Blend",
    "Temple & Monastery Use",
    "Long Burning",
  ],

  packing: [
    "50g - MRP ₹--/-", // price update karna
  ],

  usage:
    "Suitable for Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Spiritual Practices, Temples, Monasteries, and Home Fragrance.",

  howToUse: [
    "Place the dhoop stick in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the ancient Sudarshan oriental aroma connect your space to a spiritual world.",
    "Never leave burning incense unattended.",
  ],
  
  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",
  img: sudarshan1,
  imgs: [sudarshan1, sudarshan2, sudarshan3],
},
{
  id: "manthan-dhoop-stick",
  name: "Prakhyat Premium Manthan Dhoop Sticks",
  type: "Dhoop Stick",
  tier: "Premium",
  fragrance: "Fancy Floral",
  scent: "Fancy Floral Accords, Natural & Pure — Long Lasting, Natural Masala Type",
  material: "Wood Powder",
  duration: "30-40 Mins",

  weight: [
    { size: "50g", mrp: "₹--" }, // price client se confirm karna
  ],

  shortDesc:
    "Premium Manthan Dhoop Sticks — a fancy floral fragrance from pure natural ingredients. Mind and sensory captivating aroma with wide spreading aura that lingers for hours after the incense has burned.",

  longDesc:
    "PRAKHYAT – PREMIUM MANTHAN – DHOOP STICKS. A fancy floral fragrance made from natural and pure ingredients, throwing a long-lasting aroma and creating a pleasant atmosphere in your surroundings. Its long-lasting note and wide-spreading aura is mind and sensory captivating — holding the aroma for hours after the burning of incense. Made from selected, pure high-quality ingredients including Flower Powders, Wood Powders, Natural Oils, Resin, and Ailanthus Malabarica — giving a very good long-lasting aroma with fancy floral accords that linger in the surrounding area, creating a pleasant atmosphere in your living space and spreading quickly across large spaces.",

  benefits: [
    "Fancy Floral fragrance made from pure natural & premium ingredients",
    "Mind and sensory captivating aroma with wide spreading aura",
    "Long-lasting note that holds fragrance for hours after burning",
    "Creates a Pleasant & Refreshing Atmosphere in your surroundings",
    "Very special for Pooja, Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress and brings Peace & Positive Energy to your living",
  ],

  highlights: [
    "Fancy Floral Accords",
    "Mind Captivating Aroma",
    "Wide Spreading Aura",
    "Long Burning",
  ],

  packing: [
    "50g - MRP ₹--/-", // price update karna
  ],

  usage:
    "Suitable for Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the dhoop stick in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the fancy Manthan floral aroma captivate your senses and fill your space.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: manthan1,
  imgs: [manthan1, manthan2, manthan3],
},

{
  id: "pleasant-dhoop-stick",
  name: "Prakhyat Premium Pleasant Masala Dhoop Sticks",
  type: "Dhoop Stick",
  tier: "Premium",
  fragrance: "Floral Accord",
  scent: "Floral Accord, Spicy Base, Smooth & Powdery — Natural Masala Type",
  material: "Wood Powder",
  duration: "30-40 Mins",

  weight: [
    { size: "50g", mrp: "₹--" }, // price client se confirm karna
  ],

  shortDesc:
    "Premium Pleasant Masala Dhoop Sticks — a fine crafted floral accord with a spicy base. Smooth, powdery fragrance that fills your living with a warmth loved and cherished every single time.",

  longDesc:
    "PRAKHYAT – PREMIUM PLEASANT MASALA – DHOOP STICKS. A fine crafted Dhoop Stick spreading a floral accord with a spicy base — although mainly a flowery type, it fills your living with a smooth fragrance loved and cherished most of the time. Giving it a special place for Puja, Meditation, Yoga, relieving Stress, and bringing Peace and Positive Energy to your living. Made from selected, pure high-quality ingredients including Flower Powders, Wood Powders, Natural Oils, Resin, and Ailanthus Malabarica — giving a very good long-lasting aroma with a floral accord smooth and powdery that lingers in the surrounding area, creating a pleasant atmosphere in your living space and spreading quickly across large spaces.",

  benefits: [
    "Fine crafted Floral Accord fragrance with a warm spicy base note",
    "Smooth & powdery aroma loved and cherished every time it burns",
    "Lingering aroma effect that spreads quickly across large spaces",
    "Creates a Pleasant & Refreshing Atmosphere in your surroundings",
    "Very special for Pooja, Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress and brings Peace & Positive Energy to your living",
  ],

  highlights: [
    "Floral Accord Aroma",
    "Spicy Base Note",
    "Smooth & Powdery",
    "Long Burning",
  ],

  packing: [
    "50g - MRP ₹--/-", // price update karna
  ],

  usage:
    "Suitable for Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the dhoop stick in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the Pleasant floral aroma fill your space with calm and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: pleasant1,
  imgs: [pleasant1, pleasant2, pleasant3],
},

{
  id: "shristhi-dhoop-stick",
  name: "Prakhyat Shristhi Luxury Dhoop Sticks",
  type: "Dhoop Stick",
  tier: "Luxury",
  fragrance: "Amber Rose Wood",
  scent: "High Class Rose, Amber, Wood, Natural Resins — Strong Rosy Powdery, Natural Masala Type",
  material: "Wood Powder",
  duration: "30-40 Mins",

  weight: [
    { size: "50g", mrp: "₹--" }, // price client se confirm karna
  ],

  shortDesc:
    "Shristhi Luxury Dhoop Sticks — an irresistible combination of High Class Rose, Amber & Wood with natural resins. Strong rosy powdery fragrance felt from long distances — a favourite that makes you fall for it again and again.",

  longDesc:
    "PRAKHYAT – SHRISTHI – LUXURY DHOOP STICKS. One of the favourite fragrances which is irresistible by its users — Shristhi Luxury Dhoop Sticks is a combination of High Class Rose, Amber, and Wood mixed with Natural Resins, throwing a unique aroma which can be felt from long distances. A strong rosy powdery fragrance incense that makes you fall for it again and again. Made from pure high-quality ingredients including Flower Powders, Wood Powders, Natural Oils, Resin, and Ailanthus Malabarica — giving a very good long-lasting aroma that lingers in the surrounding area, creating a pleasant atmosphere in your living space and spreading quickly across large spaces.",

  benefits: [
    "Irresistible High Class Rose, Amber & Wood fragrance with natural resin notes",
    "Strong rosy powdery aroma felt from long distances — truly unforgettable",
    "Lingering aroma effect that spreads quickly across large spaces",
    "Creates a Pleasant & Refreshing Atmosphere in your surroundings",
    "Very special for Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress and brings Peace & Positive Energy to your living",
  ],

  highlights: [
    "Amber Rose Wood Aroma",
    "Strong Rosy Fragrance",
    "Irresistible Scent",
    "Long Burning",
  ],

  packing: [
    "50g - MRP ₹--/-", // price update karna
  ],

  usage:
    "Suitable for Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the dhoop stick in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the irresistible Shristhi aroma fill your space with warmth and positivity.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: shristhi1,
  imgs: [shristhi1, shristhi2, shristhi3],
},
{
  id: "guggul-dhoop-stick",
  name: "Prakhyat Natural Guggul Dhoop Sticks",
  type: "Dhoop Stick",
  tier: "Luxury",
  fragrance: "Natural Guggul Resin",
  scent: "Natural Guggal, Frankincense, Resinoid, Floral — Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "30-40 Mins",

  weight: [
    { size: "50g", mrp: "₹--" }, // price client se confirm karna
  ],

  shortDesc:
    "Natural Guggul Dhoop Sticks derived from pure Guggal resin, Frankincense & floral resins — an ancient oriental fragrance of unmatched uniqueness, used since ages for spiritual rituals & divine atmosphere.",

  longDesc:
    "PRAKHYAT – NATURAL GUGGUL – DHOOP STICKS. Derived from resins of Natural Guggal, Frankincense, Flowers, and Resinoid — all giving an oriental type of fragrance unmatched for its uniqueness and deep holding. A natural source of aroma since ancient times, people used to travel from one place to another carrying Guggal and Frankincense for religious and spiritual rituals. Made from selected, pure high-quality ingredients including Flower Powders, Wood Powders, Natural Oils, Resin, and Ailanthus Malabarica — giving a very good long-lasting aroma with a natural Guggal mix of resins that lingers in the surrounding area, creating a pleasant atmosphere in your living space and spreading quickly across large spaces.",

  benefits: [
    "Ancient Oriental fragrance from Natural Guggal, Frankincense & Resinoid resins",
    "A sacred aroma used since ancient times for religious & spiritual rituals",
    "Lingering aroma effect that spreads quickly across large spaces",
    "Creates a Pleasant & Refreshing Atmosphere in your surroundings",
    "Very special for Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress and brings Peace & Positive Energy to your living",
  ],

  highlights: [
    "Pure Guggul Resin",
    "Temple Fragrance",
    "Sacred Aroma",
    "Long Burning",
  ],

  packing: [
    "50g - MRP ₹--/-", // price update karna
  ],

  usage:
    "Suitable for Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the dhoop stick in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the sacred Guggul aroma purify your space with divine fragrance.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: guggul1,
  imgs: [guggul1, guggul2, guggul3],
},

{
  id: "kashmiri-kastoori-dhoop-stick",
  name: "Prakhyat Kashmiri Kastoori Luxury Dhoop Sticks",
  type: "Dhoop Stick",
  tier: "Luxury",
  fragrance: "Kashmiri Kastoori Musk",
  scent: "Strong Dark Musk, Floral Undertones, Smoky, Natural Resin — Pure Natural Masala Type",
  material: "Wood Powder",
  duration: "30-40 Mins",

  weight: [
    { size: "50g", mrp: "₹--" }, // price client se confirm karna
  ],

  shortDesc:
    "Luxury Kashmiri Kastoori Dhoop Sticks with a strong, vibrant dark musk aroma — blended with floral notes & natural resins, evoking the true essence of real forest deer musk from the woods of Kashmir.",

  longDesc:
    "PRAKHYAT – KASHMIRI KASTOORI – LUXURY DHOOP STICKS. A very Strong, Vibrant, Dark Musky note with an undercurrent of flowery notes blended with natural resins, giving a high-grade fragrance — a true reminiscence of real forest Deer Musk whispering from the woods and spreading far distances. Made from pure high-quality ingredients including Flower Powders, Wood Powders, Natural Oils, Resin, and Ailanthus Malabarica — giving a very good long-lasting aroma with a real Kastoori and smoky fragrance that lingers in the surrounding area, creating a pleasant atmosphere in your living space and spreading quickly across large spaces.",

  benefits: [
    "Strong Vibrant Dark Musk fragrance with floral undertones & natural resin notes",
    "True reminiscence of real Kashmiri forest Deer Musk aroma",
    "Lingering aroma effect that spreads quickly across large spaces",
    "Creates a Pleasant & Refreshing Atmosphere in your surroundings",
    "Very special for Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress and brings Peace & Positive Energy to your living",
  ],

  highlights: [
    "Kastoori Musk Aroma",
    "Warm Fragrance",
    "Luxury Feel",
    "Long Burning",
  ],

  packing: [
    "50g - MRP ₹--/-", // price update karna
  ],

  usage:
    "Suitable for Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the dhoop stick in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the Royal Kastoori Musk aroma fill your space with warmth and calm.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: kastoori1,
  imgs: [kastoori1, kastoori2, kastoori3],
},

{
  id: "supreme-sandal-dhoop-stick",
  name: "Prakhyat Sandal Supreme Luxury Dhoop Sticks",
  type: "Dhoop Stick",
  tier: "Luxury",
  fragrance: "Pure Sandalwood",
  scent: "Pure Sandal, Creamy, Woody, Smoky, Spicy — High Class Sandalwood, Natural Masala Type",
  material: "Wood Powder",
  duration: "30-40 Mins",

  weight: [
    { size: "50g", mrp: "₹--" }, // price client se confirm karna
  ],

  shortDesc:
    "Sandal Supreme Luxury Dhoop Sticks — a top-notch incense experience combining Pure Sandal with creamy, woody, smoky & spicy notes. Strong, mesmerising & long-lasting — a favourite addiction for perfume & incense lovers.",

  longDesc:
    "PRAKHYAT – SANDAL SUPREME – LUXURY DHOOP STICKS. A luxury created for the top-notch area of incense burning — Sandal Supreme is a combination of Pure Sandal with creamy, woody, smoky, and spicy notes giving it an outstanding burning incense experience. Its high-quality aroma is very strong, long-lasting, and mesmerising — a perfume and incense lover's favourite addiction. Made from pure high-quality ingredients including Flower Powders, Wood Powders, Natural Oils, Resin, and Ailanthus Malabarica — giving a very good long-lasting aroma that lingers in the surrounding area, creating a pleasant atmosphere in your living space and spreading quickly across large spaces.",

  benefits: [
    "Luxury Pure Sandal fragrance layered with Creamy, Woody, Smoky & Spicy notes",
    "Very strong, high-quality & mesmerising aroma — a perfume lover's favourite",
    "Lingering aroma effect that spreads quickly across large spaces",
    "Creates a Pleasant & Refreshing Atmosphere in your surroundings",
    "Very special for Meditation, Yoga, Aromatherapy & Garden Fragrance",
    "Relieves Stress and brings Peace & Positive Energy to your living",
  ],

  highlights: [
    "Premium Sandalwood",
    "Temple Use",
    "Luxury Aroma",
    "Long Burning",
  ],

  packing: [
    "50g - MRP ₹--/-", // price update karna
  ],

  usage:
    "Suitable for Pooja, Meditation, Yoga, Aromatherapy, Garden Fragrance, Spiritual Practices, Temples, and Home Fragrance.",

  howToUse: [
    "Place the dhoop stick in a suitable incense holder or stand.",
    "Light the tip and allow it to flame for 5–10 seconds.",
    "Gently blow out the flame — the tip should glow and emit fragrant smoke.",
    "Place the holder in a safe, well-ventilated area away from flammables.",
    "Let the luxurious Sandal Supreme aroma fill your space with warmth and calm.",
    "Never leave burning incense unattended.",
  ],

  safety:
    "Keep away from children and pets. Always use in ventilated spaces. Store in a cool, dry place away from direct sunlight. Keep away from flammable materials.",

  flipkartUrl: "#",

  img: sandal2,
  imgs: [sandal2, sandal1, sandal3],
},
];



export const ALL_PRODUCTS = [...AGARBATTI, ...DHOOP_CONE, ...DHOOP_STICK];
